
// TODO P3.2 strict migration: pending
/**
 * src/modules/settings-tabs.js — Faza D.3.2 ESM migration (auto)
 */

import { $currentUser } from '../stores/auth.js';
// Sesja 3.6 — Settings/Dashboard nanostores migration
import { $usersList, $rolesList } from '../stores/settings.js';
import { $adminUpdatesList, $dashboardUpdatesLimit } from '../stores/dashboard.js';
import type { AllegroAccount } from '../types/dto.ts';
import {
  DASHBOARD_WIDGET_DEFS,
  allDashboardWidgetKeys,
} from './dashboard-widget-visibility.ts';
import { zamontujWysiwyg } from './wysiwyg.ts';
import { wygasIUsun, ikony, podmienElement, zapamietajWidok } from './plynne.ts';

/** Załącznik szablonu e-mail (email_templates.attachments_json): PDF faktury z AKTYWNEGO systemu
 *  fakturowania (SellBase / wFirma / kolejny) albo własny plik z uploadu (/api/email/attachments/upload). */
interface EmailTemplateAttachment {
  type: 'invoice_pdf' | 'file';
  path?: string;
  name?: string;
  mime?: string;
  size?: number;
}

/** Szablon e-mail (getEmailTemplates() / form). */
interface EmailTemplate {
  id?: number | string;
  name?: string;
  code?: string;
  event_type?: string;
  language?: string;
  subject_template?: string;
  html_template?: string;
  text_template?: string;
  enabled?: boolean | number;
  is_global?: boolean;
  attachments?: EmailTemplateAttachment[];
  /** warunki wysyłki automatycznej dla zdarzeń dokumentu: typ dokumentu / seria (puste = każdy) */
  filters?: { document_types?: string[]; series_ids?: number[] };
  [k: string]: unknown;
}

/** Definicja modułu uprawnień (MODULE_DEFS / getModules()). */
interface ModuleDef {
  key: string;
  label?: string;
  desc?: string;
}

var state: any = (typeof window !== 'undefined' && (window as any).__sbState) || (function() {
  var _p = new Proxy({}, {
    get: function(_, k) { return (window as any).__sbState ? (window as any).__sbState[k] : undefined; },
    set: function(_, k, v) { if ((window as any).__sbState) (window as any).__sbState[k] = v; return true; },
    has: function(_, k) { return (window as any).__sbState ? (k in (window as any).__sbState) : false; },
  });
  return _p;
})();
// Lazy delegates (top-level — esbuild scope-safe + cross-module load-order safe)
// @ts-ignore -- TS6133 unused
function _nipInitInlineButton(this: any, ...args: any[]) { return (((window as any).__sbExports && (window as any).__sbExports._nipInitInlineButton) || (window as any)._nipInitInlineButton).apply(this, args); }
function closeModal(this: any, ...args: any[]) { return (((window as any).__sbExports && (window as any).__sbExports.closeModal) || window.closeModal).apply(this, args); }
function openModal(this: any, ...args: any[]) { return (((window as any).__sbExports && (window as any).__sbExports.openModal) || window.openModal).apply(this, args); }
function renderAutomationsTab(this: any, ...args: any[]) { return (((window as any).__sbExports && (window as any).__sbExports.renderAutomationsTab) || window.renderAutomationsTab).apply(this, args); }
function renderCouriersTab(this: any, ...args: any[]) { return (((window as any).__sbExports && (window as any).__sbExports.renderCouriersTab) || window.renderCouriersTab).apply(this, args); }
function renderDashboardUpdates(this: any, ...args: any[]) { return (((window as any).__sbExports && (window as any).__sbExports.renderDashboardUpdates) || window.renderDashboardUpdates).apply(this, args); }
function renderKsefHubSettings(this: any, ...args: any[]) { return (((window as any).__sbExports && (window as any).__sbExports.renderKsefHubSettings) || window.renderKsefHubSettings).apply(this, args); }
function renderOrderStatusesTab(this: any, ...args: any[]) { return (((window as any).__sbExports && (window as any).__sbExports.renderOrderStatusesTab) || window.renderOrderStatusesTab).apply(this, args); }
function renderSellBasePrintSettingsTab(this: any, ...args: any[]) { return (((window as any).__sbExports && (window as any).__sbExports.renderSellBasePrintSettingsTab) || (window as any).renderSellBasePrintSettingsTab).apply(this, args); }
function renderWfirmaSettings(this: any, ...args: any[]) { return (((window as any).__sbExports && (window as any).__sbExports.renderWfirmaSettings) || (window as any).renderWfirmaSettings).apply(this, args); }
function showConfirm(this: any, ...args: any[]) { return (((window as any).__sbExports && (window as any).__sbExports.showConfirm) || window.showConfirm).apply(this, args); }
function updateTypeMeta(this: any, ...args: any[]) { return (((window as any).__sbExports && (window as any).__sbExports.updateTypeMeta) || window.updateTypeMeta).apply(this, args); }

// Faza C.3.pricing — pricing (452 linii) extracted to src/modules/pricing.js
// Faza C.3.billing — billing (415 linii) extracted to src/modules/billing.js
function renderSettings() {
    // Globalny changelog jest chroniony przez backend wyłącznie dla master_admin.
    // Nie pokazuj zwykłemu managerowi/adminowi zakładki, która kończy się serią 403.
    var updatesTab = document.querySelector('.settings-tab[data-tab="updates"]') as HTMLElement | null;
    if (updatesTab) updatesTab.style.display = canManageUpdates() ? '' : 'none';
    if (state.settingsTab === 'updates' && !canManageUpdates()) state.settingsTab = 'marketplace';
    // 2026-10-26 E1: „Asystent AI (Grok Bot)” — tylko właściciel (backend /api/agent-admin i tak odpowiada 403).
    var aiTab = document.querySelector('.settings-tab[data-tab="asystent-ai"]') as HTMLElement | null;
    if (aiTab) aiTab.style.display = canManageAsystentAi() ? '' : 'none';
    if (state.settingsTab === 'asystent-ai' && !canManageAsystentAi()) state.settingsTab = 'marketplace';
    activateSettingsTab(state.settingsTab);
}

function activateSettingsTab(tabName: string) {
    if (tabName === 'inpost') tabName = 'couriers';
    // 2026-07-08 MARKETPLACE HUB: 6 dawnych zakładek marketplace → jedna 'marketplace'.
    // Stara nazwa (localStorage / routes typu /prestashop-settings) = deep-link:
    // hub otwiera od razu szczegóły właściwego marketplace'u (__mpHubTarget).
    if (['allegro', 'prestashop', 'erli', 'ebay', 'tiktok', 'vonhalsky'].indexOf(tabName) !== -1) {
        (window as any).__mpHubTarget = tabName;
        tabName = 'marketplace';
    }
    if (tabName === 'updates' && !canManageUpdates()) tabName = 'marketplace';
    if (tabName === 'asystent-ai' && !canManageAsystentAi()) tabName = 'marketplace';
    // 2026-04-30: 'company' usunięte (przeniesione do drawera "Profil firmy" w user menu).
    if (tabName === 'company') tabName = 'marketplace';
    state.settingsTab = tabName;

    // Update tab buttons
    document.querySelectorAll('.settings-tab').forEach(function(t: any) {
      t.classList.remove('active');
      if (t.dataset.tab === tabName) t.classList.add('active');
    });

    // Update panels
    document.querySelectorAll('.settings-panel').forEach(function(p: any) {
      p.classList.remove('active');
    });
    var panel = document.getElementById('panel-' + tabName);
    if (panel) {
      panel.classList.add('active');
    }

    // Render content
    switch (tabName) {
      case 'marketplace': {
        // Race load-order: render trasy bywa szybszy niż chunk marketplaces
        // (niesie renderMarketplaceHub + wszystkie renderery poziomu 2) — retry.
        var _mpW: any = window as any;
        var _mpFn = (_mpW.__sbExports && _mpW.__sbExports.renderMarketplaceHub) || _mpW.renderMarketplaceHub;
        if (typeof _mpFn === 'function') { _mpFn(); break; }
        var _mpTries = 0;
        var _mpTimer = setInterval(function() {
          var f = (_mpW.__sbExports && _mpW.__sbExports.renderMarketplaceHub) || _mpW.renderMarketplaceHub;
          if (typeof f === 'function') {
            clearInterval(_mpTimer);
            if (state.settingsTab === 'marketplace') f();
          } else if (++_mpTries > 40) { clearInterval(_mpTimer); }
        }, 250);
        break;
      }
      case 'couriers': renderCouriersTab(); break;
      case 'autolabels': {
        // Race load-order: route render bywa szybszy niż chunk marketplaces (niesie
        // renderAutoLabelsTab). Zamiast wyjątku/pustego panelu — krótki retry.
        var _alW: any = window as any;
        var _alFn = (_alW.__sbExports && _alW.__sbExports.renderAutoLabelsTab) || _alW.renderAutoLabelsTab;
        if (typeof _alFn === 'function') { _alFn(); break; }
        var _alTries = 0;
        var _alTimer = setInterval(function() {
          var f = (_alW.__sbExports && _alW.__sbExports.renderAutoLabelsTab) || _alW.renderAutoLabelsTab;
          if (typeof f === 'function') {
            clearInterval(_alTimer);
            if (state.settingsTab === 'autolabels') f();
          } else if (++_alTries > 40) { clearInterval(_alTimer); }
        }, 250);
        break;
      }
      case 'production': {
        // 2026-07-09 ZGŁOSZENIA BRAKÓW: retry-guard jak autolabels (race chunk-load)
        var _prW: any = window as any;
        var _prFn = (_prW.__sbExports && _prW.__sbExports.renderProductionTab) || _prW.renderProductionTab;
        if (typeof _prFn === 'function') { _prFn(); break; }
        var _prTries = 0;
        var _prTimer = setInterval(function() {
          var f = (_prW.__sbExports && _prW.__sbExports.renderProductionTab) || _prW.renderProductionTab;
          if (typeof f === 'function') {
            clearInterval(_prTimer);
            if (state.settingsTab === 'production') f();
          } else if (++_prTries > 40) { clearInterval(_prTimer); }
        }, 250);
        break;
      }
      case 'packing': {
        // 2026-09-25: ustawienia pakowania (źródło zdjęć w oknie pakowania) — moduł packing-settings.ts (main.js)
        var _pkW: any = window as any;
        var _pkFn = _pkW.__sbExports && _pkW.__sbExports.renderPackingSettingsTab;
        if (typeof _pkFn === 'function') _pkFn();
        break;
      }
      case 'reply-templates': {
        // 2026-09-30: szablony odpowiedzi w wiadomościach — moduł szablony-odpowiedzi-ustawienia.ts (main.js)
        var _szW: any = window as any;
        var _szFn = _szW.__sbExports && _szW.__sbExports.renderSzablonyOdpowiedziTab;
        if (typeof _szFn === 'function') _szFn();
        break;
      }
      case 'asystent-ai': {
        // 2026-10-26 E1 API agenta: Asystent AI (Grok Bot) — moduł asystent-ai-ustawienia.ts (main.js)
        var _aiW: any = window as any;
        var _aiFn = _aiW.__sbExports && _aiW.__sbExports.renderAsystentAiTab;
        if (typeof _aiFn === 'function') _aiFn();
        break;
      }
      case 'sellbase-print': renderSellBasePrintSettingsTab(); break;
      case 'email': renderEmailTab(); break;
      case 'users': renderUsersTab(); break;
      case 'updates': renderUpdatesTab(); break;
      case 'automations': renderAutomationsTab(); break;
      case 'order-statuses': renderOrderStatusesTab(); break;
      case 'ksef-hub': renderKsefHubSettings(); break;
      case 'wfirma': renderWfirmaSettings(); break;
      case 'gs1': {
        // S-24 (25.09.2026): GS1 (MojeGS1) — moduł gs1.ts (main.js); ten sam retry-guard co przy chunkach
        var _g1W: any = window as any;
        var _g1Fn = _g1W.__sbExports && _g1W.__sbExports.renderGs1SettingsTab;
        if (typeof _g1Fn === 'function') { _g1Fn(); break; }
        var _g1Tries = 0;
        var _g1Timer = setInterval(function() {
          var f = _g1W.__sbExports && _g1W.__sbExports.renderGs1SettingsTab;
          if (typeof f === 'function') { clearInterval(_g1Timer); if (state.settingsTab === 'gs1') f(); }
          else if (++_g1Tries > 40) { clearInterval(_g1Timer); }
        }, 250);
        break;
      }
      // 'company' nie istnieje od refaktoru 2026-04-29 — Profil firmy otwierany z user menu jako drawer
    }

    lucide.createIcons();
}

/* -----------------------------------------------
     Settings — P4U Tab (PRZENIESIONE)
     2026-06-22: konfiguracja importu P4U przeniesiona do Produkty → „Import ofert".
     Tu zostaje tylko notka-link. Backendowe p4u_url NIE usunięte (back-compat) —
     hub importu (products/import-offers.ts) operuje na tym samym ustawieniu.
     ----------------------------------------------- */
async function renderP4uTab() {
    var panel = document.getElementById('panel-p4u');
    if (!panel) return;
    panel.innerHTML =
      '<div class="settings-card">' +
        '<div class="settings-card-header">' +
          '<div><div class="settings-card-title"><i data-lucide="upload" style="width:16px;height:16px;vertical-align:middle"></i> Import P4U został przeniesiony</div>' +
          '<div class="settings-card-subtitle">Konfiguracja i uruchamianie importu z P4U znajdują się teraz w sekcji <strong>Produkty → Import produktów</strong> razem z pozostałymi źródłami (m.in. Sellasist).</div></div>' +
        '</div>' +
        '<div class="form-actions" style="padding:0 16px 16px">' +
          '<button type="button" class="btn-primary" id="p4u-goto-import"><i data-lucide="arrow-right" style="width:15px;height:15px"></i> Przejdź do Import produktów</button>' +
        '</div>' +
      '</div>';
    var gotoBtn = document.getElementById('p4u-goto-import');
    if (gotoBtn) {
      gotoBtn.addEventListener('click', function() {
        var nav = (window as any).navigate || ((window as any).__sbExports && (window as any).__sbExports.navigate);
        if (typeof nav === 'function') nav('/catalog-v2?section=tools&tool=import');
        else window.location.href = '/catalog-v2?section=tools&tool=import';
      });
    }
    lucide.createIcons();
}

// Backward-compat: stara nazwa renderCompanyTab — gdyby coś jeszcze ją wołało, przekierowanie do drawera profilu firmy.
async function renderCompanyTab() {
    if (typeof window.openCompanyDrawer === 'function') {
      window.openCompanyDrawer();
    } else {
      console.warn('[settings-tabs] renderCompanyTab() obsolete — use openCompanyDrawer() instead');
    }
}

/* -----------------------------------------------
     Settings — Allegro Tab
     ----------------------------------------------- */
/* State for live Allegro data */
var allegroState: any = {
    accounts: [],
    liveOrders: [],
    backendAvailable: false,
    syncing: false,
    oauthListenerBound: false,
    oauthConfig: null
};
// FIX (Faza E.1, 2026-04-29): guard — settings-tabs.js może być wykonane PRZED app.js
// (przy nowym ESM import graph z allegro-tab.js → settings-tabs.js → tu), a app.js
// inicjalizuje (window as any).__sbStateExt. Bez guarda crash "Cannot set properties of undefined".
if (!(window as any).__sbStateExt) (window as any).__sbStateExt = {};
(window as any).__sbStateExt.allegroState = allegroState;

function findAllegroAccountById(accountId: number | string) {
    var id = parseInt(accountId as string, 10);
    for (var i = 0; i < allegroState.accounts.length; i++) {
      if (parseInt(allegroState.accounts[i].id, 10) === id) return allegroState.accounts[i];
    }
    return null;
}

function getAccountDisplayName(acc: AllegroAccount | null | undefined) {
    if (!acc) return 'Konto';
    // Priority: display_name > name (custom) > allegro_user_name > fallback
    var displayName = (acc.display_name || '').trim();
    if (displayName) return displayName;
    var customName = (acc.name || '').trim();
    var autoName = (acc.allegro_user_name || '').trim();
    if (customName && customName !== 'Allegro Sandbox' && customName !== autoName && customName !== (autoName + ' (' + autoName + ')')) {
      return customName;
    }
    return autoName || customName || ('Konto ' + (acc.id || ''));
}

// Faza C.3.allegro-tab — allegro-tab (1732 linii) extracted to src/modules/allegro-tab.js
function getInPostStatusSummary(account: any, statusOverride: any) {
    var cfg = (account && account.config) ? account.config : {};
    var src = Object.assign({}, (account && account.integration_status) ? account.integration_status : {});
    if (statusOverride && account && parseInt(statusOverride.account_id || '0', 10) === parseInt(account.id || '0', 10)) {
      src = Object.assign(src, statusOverride);
    }
    var boolFrom = function(v: unknown) {
      return v === true || v === 1 || v === '1' || String(v || '').toLowerCase() === 'true';
    };
    var hasToken = !!String(cfg.api_token || cfg.api_key || cfg.token || '').trim();
    var hasOrg = !!String(cfg.organization_id || '').trim();
    var credentialsSaved = (src.credentials_saved !== undefined) ? boolFrom(src.credentials_saved) : (hasToken && hasOrg);
    var lastTestStatus = String(src.last_test_status || cfg.last_test_status || '').toLowerCase();
    var testPassed = (src.test_passed !== undefined) ? boolFrom(src.test_passed) : (boolFrom(cfg.verified) || lastTestStatus === 'success' || lastTestStatus === 'passed' || lastTestStatus === 'ok');
    var webhookConfigured = (src.webhook_configured !== undefined) ? boolFrom(src.webhook_configured) : boolFrom(cfg.webhook_configured);
    var active = (src.active !== undefined) ? boolFrom(src.active) : (credentialsSaved && testPassed && webhookConfigured);
    return {
      environment: src.environment || ((String(cfg.is_sandbox) === '1' || cfg.is_sandbox === true) ? 'sandbox' : 'production'),
      organization_id: src.organization_id || String(cfg.organization_id || ''),
      api_key_present: (src.api_key_present !== undefined) ? boolFrom(src.api_key_present) : hasToken,
      credentials_saved: credentialsSaved,
      test_passed: testPassed,
      last_test_status: lastTestStatus || (testPassed ? 'success' : 'not_tested'),
      last_tested_at: String(src.last_tested_at || cfg.last_tested_at || ''),
      last_error: String(src.last_error || cfg.last_error || ''),
      webhook_configured: webhookConfigured,
      webhook_configured_at: String(src.webhook_configured_at || cfg.webhook_configured_at || ''),
      active: active,
      webhook_url: String(src.webhook_url || ''),
      account_id: account ? account.id : null
    };
}

// Faza C.3.courier — courier (631 linii) extracted to src/modules/courier.js
async function renderEmailTab() {
    var panel = document.getElementById('panel-email');
    if (!panel) return;

    panel.innerHTML = '<div class="settings-card"><div style="padding:var(--space-5)">Ładowanie modułu e-mail...</div></div>';
    try {
      var results = await Promise.all([
        SellBaseAPI.getEmailSettings(),
        SellBaseAPI.getEmailTemplates(),
        SellBaseAPI.getEmailLogs({ limit: 30 })
      ]);
      var settings = results[0] || {};
      var templates = Array.isArray(results[1]) ? results[1] : [];
      var logs = Array.isArray(results[2]) ? results[2] : [];

      var html =
        '<div class="settings-card">' +
          '<div class="settings-card-header"><div><div class="settings-card-title">Konfiguracja SMTP</div><div class="settings-card-subtitle">Provider-agnostic (MVP: SMTP)</div></div></div>' +
          '<form class="settings-form" id="email-settings-form">' +
            // S-139: baner ZAWSZE w DOM (tylko chowany), żeby zapis mógł go przełączyć
            // bez przebudowy formularza (inaczej trzeba było renderEmailTab()).
            '<div id="email-inactive-banner" style="display:' + (Number(settings.is_active) === 0 ? 'flex' : 'none') + ';align-items:center;gap:8px;padding:10px 12px;margin-bottom:14px;border-radius:8px;background:rgba(245,158,11,.12);border:1px solid rgba(245,158,11,.4);color:#b45309;font-size:13px;font-weight:600"><i data-lucide="alert-triangle" style="width:16px;height:16px"></i> Wysyłka e-mail jest WYŁĄCZONA — żadne maile nie są wysyłane ani kolejkowane (zero błędów w historii).</div>' +
            '<div class="form-grid">' +
              '<div class="form-group full-width"><label>Wysyłka e-mail (główny przełącznik)</label><select class="form-select" name="is_active"><option value="1"' + (Number(settings.is_active) !== 0 ? ' selected' : '') + '>Włączona — wysyłaj wg szablonów i reguł</option><option value="0"' + (Number(settings.is_active) === 0 ? ' selected' : '') + '>Wyłączona — nie wysyłaj i nie kolejkuj</option></select></div>' +
              '<div class="form-group"><label>Typ providera</label><select class="form-select" name="provider_type"><option value="smtp"' + (settings.provider_type === 'smtp' ? ' selected' : '') + '>SMTP</option><option value="api"' + (settings.provider_type === 'api' ? ' selected' : '') + '>API</option></select></div>' +
              '<div class="form-group"><label>SMTP host</label><input class="form-input" name="smtp_host" value="' + escapeAttr(settings.smtp_host || '') + '"></div>' +
              '<div class="form-group"><label>SMTP port</label><input class="form-input" type="number" name="smtp_port" value="' + escapeAttr(String(settings.smtp_port || 587)) + '"></div>' +
              '<div class="form-group"><label>SMTP login</label><input class="form-input" name="smtp_username" value="' + escapeAttr(settings.smtp_username || '') + '"></div>' +
              '<div class="form-group"><label>SMTP hasło</label><input class="form-input" type="password" name="smtp_password" placeholder="' + escapeAttr(settings.smtp_password_masked || '') + '"></div>' +
              '<div class="form-group"><label>Szyfrowanie</label><select class="form-select" name="smtp_encryption"><option value="tls"' + (settings.smtp_encryption === 'tls' ? ' selected' : '') + '>TLS</option><option value="ssl"' + (settings.smtp_encryption === 'ssl' ? ' selected' : '') + '>SSL</option><option value="none"' + (settings.smtp_encryption === 'none' ? ' selected' : '') + '>None</option></select></div>' +
              '<div class="form-group"><label>From e-mail</label><input class="form-input" name="from_email" value="' + escapeAttr(settings.from_email || '') + '"></div>' +
              '<div class="form-group"><label>From name</label><input class="form-input" name="from_name" value="' + escapeAttr(settings.from_name || 'SellBase') + '"></div>' +
              '<div class="form-group"><label>Reply-To</label><input class="form-input" name="reply_to" value="' + escapeAttr(settings.reply_to || '') + '"></div>' +
              '<div class="form-group"><label>Tryb faktury</label><select class="form-select" name="invoice_delivery_mode"><option value="attachment"' + (settings.invoice_delivery_mode === 'attachment' ? ' selected' : '') + '>Załącznik PDF</option><option value="link"' + (settings.invoice_delivery_mode === 'link' ? ' selected' : '') + '>Link</option><option value="both"' + (settings.invoice_delivery_mode === 'both' ? ' selected' : '') + '>Załącznik + link</option></select></div>' +
            '</div>' +
            '<div class="form-actions"><button type="submit" class="btn-primary">Zapisz konfigurację</button><button type="button" class="btn-secondary" id="email-test-btn">Wyślij test</button></div>' +
          '</form>' +
        '</div>' +
        '<div class="settings-card">' +
          '<div class="settings-card-header"><div><div class="settings-card-title">Szablony e-mail</div><div class="settings-card-subtitle">Edytowalne szablony z placeholderami</div></div><button class="btn-primary" id="email-template-add-btn"><i data-lucide="plus" style="width:15px;height:15px"></i> Dodaj szablon</button></div>' +
          '<div class="table-scroll"><table class="data-table"><thead><tr><th>Nazwa</th><th>Kod</th><th>Event</th><th>Język</th><th>Aktywny</th><th>Wersja</th><th>Akcje</th></tr></thead><tbody id="email-template-body"></tbody></table></div>' +
        '</div>' +
        '<div class="settings-card">' +
          '<div class="settings-card-header"><div><div class="settings-card-title">Historia wysyłek</div><div class="settings-card-subtitle">Ostatnie próby wysyłki</div></div><button class="btn-secondary" id="email-cleanup-btn"><i data-lucide="trash-2" style="width:14px;height:14px"></i> Wyczyść nieudane/zaległe</button></div>' +
          '<div class="table-scroll"><table class="data-table"><thead><tr><th>Data</th><th>Odbiorca</th><th>Temat</th><th>Status</th><th>Event</th></tr></thead><tbody id="email-logs-body"></tbody></table></div>' +
        '</div>';

      panel.innerHTML = html;

      var tbody = document.getElementById('email-template-body');
      if (tbody) {
        var rows = '';
        templates.forEach(function(t: any) { rows += _emailTemplateRowHtml(t); });
        tbody.innerHTML = rows || '<tr><td colspan="7" style="text-align:center;color:var(--color-text-muted)">Brak szablonów</td></tr>';
      }

      var logsBody = document.getElementById('email-logs-body');
      if (logsBody) {
        var lhtml = '';
        logs.forEach(function(l: any) {
          lhtml += '<tr><td>' + formatDateTime(l.created_at) + '</td><td>' + escapeHtml(l.recipient_email || '') + '</td><td>' + escapeHtml(l.subject || '') + '</td><td>' + (l.status === 'sent' ? '<span class="badge badge-active">Wysłano</span>' : '<span class="badge badge-inactive">Błąd</span>') + '</td><td>' + escapeHtml(l.event_type || '') + '</td></tr>';
        });
        logsBody.innerHTML = lhtml || '<tr><td colspan="5" style="text-align:center;color:var(--color-text-muted)">Brak logów</td></tr>';
      }

      bindEmailTabActions(templates, settings);
      lucide.createIcons();
    } catch (e: any) {
      panel.innerHTML = '<div class="settings-card" style="border-left:3px solid var(--color-error)"><div style="padding:var(--space-5)"><div style="font-weight:600;color:var(--color-error);margin-bottom:var(--space-2)">Błąd modułu e-mail</div><div style="font-size:var(--text-sm);color:var(--color-text-muted)">' + escapeHtml(e.message || 'Nieznany błąd') + '</div></div></div>';
    }
}

// S-139: jeden wiersz szablonu — wyodrębnione, żeby dało się dopisać/podmienić
// JEDEN wiersz (po zapisie w modalu) bez przebudowy całej tabeli/zakładki.
function _emailTemplateRowHtml(t: EmailTemplate): string {
    return '<tr data-tpl-row="' + t.id + '"><td>' + escapeHtml(t.name || '') + (t.is_global ? ' <span class="badge badge-inactive" title="Szablon systemowy (wspólny dla firm) — możesz go wyłączyć albo edytować">systemowy</span>' : '') + '</td><td><code>' + escapeHtml(t.code || '') + '</code></td><td>' + escapeHtml(t.event_type || '') + '</td><td>' + escapeHtml(t.language || '') + '</td><td>' + (t.enabled ? '<span class="badge badge-active">Tak</span>' : '<span class="badge badge-inactive">Nie</span>') + '</td><td>' + escapeHtml(String(t.version || 1)) + '</td><td><div class="table-actions"><button class="action-btn" data-action="toggle-email-template" data-id="' + t.id + '" data-enabled="' + (t.enabled ? 1 : 0) + '" aria-label="' + (t.enabled ? 'Wyłącz' : 'Włącz') + '" title="' + (t.enabled ? 'Wyłącz wysyłkę tego szablonu' : 'Włącz wysyłkę tego szablonu') + '"><i data-lucide="' + (t.enabled ? 'toggle-right' : 'toggle-left') + '" style="width:16px;height:16px;color:' + (t.enabled ? '#16a34a' : 'var(--color-text-muted)') + '"></i></button><button class="action-btn" data-action="edit-email-template" data-id="' + t.id + '" aria-label="Edytuj"><i data-lucide="pencil" style="width:14px;height:14px"></i></button><button class="action-btn" data-action="preview-email-template" data-id="' + t.id + '" aria-label="Podgląd"><i data-lucide="eye" style="width:14px;height:14px"></i></button><button class="action-btn" data-action="delete-email-template" data-id="' + t.id + '" aria-label="Usuń"><i data-lucide="trash-2" style="width:14px;height:14px"></i></button></div></td></tr>';
}

// S-139: fetch + podmiana TYLKO tbody szablonów (bez spinnera, bez formularza SMTP
// nad listą) — wołane po zapisie/dodaniu szablonu z modala, zamiast renderEmailTab().
function _odswiezTabeleSzablonowEmail(): void {
    var tbody = document.getElementById('email-template-body');
    if (!tbody) return;
    SellBaseAPI.getEmailTemplates().then(function(lista: any) {
      var templates2 = Array.isArray(lista) ? lista : [];
      var rows = '';
      templates2.forEach(function(t: any) { rows += _emailTemplateRowHtml(t); });
      tbody!.innerHTML = rows || '<tr><td colspan="7" style="text-align:center;color:var(--color-text-muted)">Brak szablonów</td></tr>';
      ikony(tbody);
      _bindEmailTemplateRowActions(templates2);
    }).catch(function() { /* tabela zostaje jak była — toast zapisu już poszedł */ });
}

function _bindEmailTemplateRowActions(templates: EmailTemplate[]): void {
    document.querySelectorAll('[data-action="edit-email-template"]').forEach(function(btn: any) {
      if (btn._sbBound) return; btn._sbBound = true;
      btn.addEventListener('click', function(this: any) {
        var id = parseInt(this.dataset.id, 10);
        // 2026-09-09: lista (GET /api/email/templates) nie niesie html_template/text_template — edytor
        // otwierał się pusty, a „Zapisz" nadpisywał treść pustym HTML. Pełny szablon z GET po id.
        SellBaseAPI.getEmailTemplate(id).then(function(pelny: EmailTemplate) {
          if (!pelny || !pelny.id) { showToast('Nie udało się pobrać szablonu', 'error'); return; }
          openEmailTemplateModal(pelny);
        }).catch(function(err: any) { showToast(err.message || 'Nie udało się pobrać szablonu', 'error'); });
      });
    });
    document.querySelectorAll('[data-action="preview-email-template"]').forEach(function(btn: any) {
      if (btn._sbBound) return; btn._sbBound = true;
      btn.addEventListener('click', function(this: any) {
        var id = parseInt(this.dataset.id, 10);
        SellBaseAPI.previewEmailTemplate(id, {}).then(function(prev: { subject?: string; html?: string }) {
          openModal('Podgląd szablonu', '<div style="margin-bottom:var(--space-3)"><strong>Temat:</strong> ' + escapeHtml(prev.subject || '') + '</div><div style="border:1px solid var(--color-border);padding:var(--space-4);border-radius:8px;max-height:360px;overflow:auto">' + (prev.html || '') + '</div>', '<button class="btn-secondary" onclick="SellBaseApp.closeModal()">Zamknij</button>', true);
        }).catch(function(err: any) {
          showToast(err.message || 'Błąd podglądu', 'error');
        });
      });
    });
    // Szybki przełącznik Aktywny/Nieaktywny — bez wchodzenia w edycję.
    // S-139: punktowa zmiana wiersza — bez przeładowania całej zakładki (kasowało
    // niezapisany formularz SMTP nad listą, bo renderEmailTab() budował wszystko od nowa).
    document.querySelectorAll('[data-action="toggle-email-template"]').forEach(function(btn: any) {
      if (btn._sbBound) return; btn._sbBound = true;
      btn.addEventListener('click', function(this: any) {
        var id = parseInt(this.dataset.id, 10);
        var nextEnabled = parseInt(this.dataset.enabled, 10) === 1 ? 0 : 1;
        var ikonaBtn = this;
        var wiersz = this.closest('tr');
        SellBaseAPI.updateEmailTemplate(id, { enabled: nextEnabled }).then(function() {
          showToast(nextEnabled ? 'Szablon włączony' : 'Szablon wyłączony', 'success');
          ikonaBtn.dataset.enabled = String(nextEnabled);
          ikonaBtn.setAttribute('aria-label', nextEnabled ? 'Wyłącz' : 'Włącz');
          ikonaBtn.setAttribute('title', nextEnabled ? 'Wyłącz wysyłkę tego szablonu' : 'Włącz wysyłkę tego szablonu');
          ikonaBtn.innerHTML = '<i data-lucide="' + (nextEnabled ? 'toggle-right' : 'toggle-left') + '" style="width:16px;height:16px;color:' + (nextEnabled ? '#16a34a' : 'var(--color-text-muted)') + '"></i>';
          ikony(ikonaBtn);
          var badgeTd = wiersz && wiersz.children[4];
          if (badgeTd) badgeTd.innerHTML = nextEnabled ? '<span class="badge badge-active">Tak</span>' : '<span class="badge badge-inactive">Nie</span>';
          var tpl2 = (templates || []).find(function(t: EmailTemplate) { return t.id === id; });
          if (tpl2) tpl2.enabled = nextEnabled;
        }).catch(function(err: any) { showToast(err.message || 'Błąd zmiany statusu', 'error'); });
      });
    });
    // Usuwanie szablonu (z potwierdzeniem).
    document.querySelectorAll('[data-action="delete-email-template"]').forEach(function(btn: any) {
      if (btn._sbBound) return; btn._sbBound = true;
      btn.addEventListener('click', function(this: any) {
        var id = parseInt(this.dataset.id, 10);
        var tpl = (templates || []).find(function(t: EmailTemplate) { return t.id === id; });
        var nm = tpl ? (tpl.name || tpl.code || ('#' + id)) : ('#' + id);
        var wiersz = this.closest('tr');
        openModal('Usuń szablon', '<div style="font-size:13px;line-height:1.5">Czy na pewno usunąć szablon <strong>' + escapeHtml(nm) + '</strong>? Tej operacji nie można cofnąć.</div>', '<button class="btn-secondary" onclick="SellBaseApp.closeModal()">Anuluj</button><button class="btn-primary" id="email-tpl-del-confirm" style="background:var(--color-error);border-color:var(--color-error)">Usuń</button>');
        setTimeout(function() {
          var c = document.getElementById('email-tpl-del-confirm');
          if (c) c.addEventListener('click', function() {
            SellBaseAPI.deleteEmailTemplate(id).then(function() {
              closeModal();
              showToast('Szablon usunięty', 'success');
              // S-139: wiersz znika płynnie, formularz SMTP nad listą zostaje nietknięty.
              if (wiersz) wygasIUsun(wiersz);
            }).catch(function(err: any) { showToast(err.message || 'Błąd usuwania', 'error'); });
          });
        }, 50);
      });
    });
}

function bindEmailTabActions(templates: any, settings: any) {
    var form = document.getElementById('email-settings-form');
    if (form) {
      form.addEventListener('submit', function(e: any) {
        e.preventDefault();
        var payload = {
          provider_type: (form?.querySelector('[name="provider_type"]') as any)?.value,
          smtp_host: (form?.querySelector('[name="smtp_host"]') as any)?.value,
          smtp_port: parseInt((form?.querySelector('[name="smtp_port"]') as any)?.value || '587', 10),
          smtp_username: (form?.querySelector('[name="smtp_username"]') as any)?.value,
          smtp_password: (form?.querySelector('[name="smtp_password"]') as any)?.value || null,
          smtp_encryption: (form?.querySelector('[name="smtp_encryption"]') as any)?.value,
          from_email: (form?.querySelector('[name="from_email"]') as any)?.value,
          from_name: (form?.querySelector('[name="from_name"]') as any)?.value,
          reply_to: (form?.querySelector('[name="reply_to"]') as any)?.value,
          invoice_delivery_mode: (form?.querySelector('[name="invoice_delivery_mode"]') as any)?.value,
          global_footer_html: settings.global_footer_html || '',
          global_footer_text: settings.global_footer_text || '',
          is_active: parseInt((form?.querySelector('[name="is_active"]') as any)?.value || '1', 10)
        } as any;
        SellBaseAPI.updateEmailSettings(payload).then(function() {
          showToast('Zapisano konfigurację e-mail', 'success');
          // S-139: bez renderEmailTab() — formularz zostaje jak user go wypełnił
          // (wartości już są zapisane), tylko hasło się chowa i baner się przełącza.
          settings.is_active = payload.is_active;
          var baner = document.getElementById('email-inactive-banner');
          if (baner) baner.style.display = payload.is_active === 0 ? 'flex' : 'none';
          var pass = form?.querySelector('[name="smtp_password"]') as HTMLInputElement | null;
          if (pass && pass.value) { pass.value = ''; pass.placeholder = '••••••••'; }
          form?.querySelectorAll('input').forEach(function(el: any) {
            if (el.type !== 'password') el.defaultValue = el.value;
          });
          form?.querySelectorAll('select').forEach(function(sel: any) {
            [...sel.options].forEach(function(o: any) { o.defaultSelected = o.selected; });
          });
        }).catch(function(err: any) { showToast(err.message || 'Błąd zapisu konfiguracji', 'error'); });
      });
    }

    var testBtn = document.getElementById('email-test-btn');
    if (testBtn) {
      testBtn.addEventListener('click', function(this: any) {
        openModal('Wyślij e-mail testowy', '<div class="form-group"><label>Adres odbiorcy</label><input id="email-test-to" class="form-input" placeholder="test@twojadomena.pl"></div>', '<button class="btn-secondary" onclick="SellBaseApp.closeModal()">Anuluj</button><button class="btn-primary" id="email-test-send">Wyślij</button>');
        setTimeout(function() {
          var sendBtn = document.getElementById('email-test-send');
          if (!sendBtn) return;
          sendBtn.addEventListener('click', function(this: any) {
            var to = (document.getElementById('email-test-to') as any).value.trim();
            if (!to) { showToast('Podaj adres e-mail', 'error'); return; }
            SellBaseAPI.testEmailSettings({ to_email: to }).then(function() {
              closeModal(); showToast('E-mail testowy wysłany', 'success');
              // AUDYT 2026-08-11: wpis testu ląduje w logach, ale tabela „Historia wysyłek"
              // pod spodem nie odświeżała się do F5. Punktowy refetch tbody, bez re-renderu zakładki.
              setTimeout(function() {
                SellBaseAPI.getEmailLogs({ limit: 30 }).then(function(logs: any) {
                  var body = document.getElementById('email-logs-body');
                  if (!body || !Array.isArray(logs)) return;
                  var lhtml = '';
                  logs.forEach(function(l: any) {
                    lhtml += '<tr><td>' + formatDateTime(l.created_at) + '</td><td>' + escapeHtml(l.recipient_email || '') + '</td><td>' + escapeHtml(l.subject || '') + '</td><td>' + (l.status === 'sent' ? '<span class="badge badge-active">Wysłano</span>' : '<span class="badge badge-inactive">Błąd</span>') + '</td><td>' + escapeHtml(l.event_type || '') + '</td></tr>';
                  });
                  body.innerHTML = lhtml || '<tr><td colspan="5" style="text-align:center;color:var(--color-text-muted)">Brak logów</td></tr>';
                }).catch(function() {});
              }, 800);
            }).catch(function(err: any) { showToast(err.message || 'Błąd wysyłki testowej', 'error'); });
          });
        }, 50);
      });
    }

    var addTplBtn = document.getElementById('email-template-add-btn');
    if (addTplBtn) addTplBtn.addEventListener('click', function(this: any) { openEmailTemplateModal(null); });

    // S-139: akcje wierszy (edytuj/podgląd/toggle/usuń) — wyodrębnione do
    // _bindEmailTemplateRowActions, bo po zapisie w modalu podmieniamy tylko
    // tbody i trzeba te same bindy powtórzyć na nowych wierszach.
    _bindEmailTemplateRowActions(templates);
    // Wyczyść nieudane/zaległe joby + historię błędów.
    var cleanupBtn = document.getElementById('email-cleanup-btn');
    if (cleanupBtn) cleanupBtn.addEventListener('click', function() {
      openModal('Wyczyść historię', '<div style="font-size:13px;line-height:1.5">Anuluje wszystkie zaległe/nieudane wysyłki i czyści historię błędów. Wysłane (udane) pozostają. Kontynuować?</div>', '<button class="btn-secondary" onclick="SellBaseApp.closeModal()">Anuluj</button><button class="btn-primary" id="email-cleanup-confirm">Wyczyść</button>');
      setTimeout(function() {
        var c = document.getElementById('email-cleanup-confirm');
        if (c) c.addEventListener('click', function() {
          SellBaseAPI.cleanupEmailJobs().then(function(r: any) {
            closeModal();
            showToast('Wyczyszczono: ' + (r.jobs_cancelled || 0) + ' wysyłek, ' + (r.logs_cleared || 0) + ' wpisów historii', 'success');
            // S-139: tylko sekcja logów (najnowsze 30) — bez przeładowania całej zakładki.
            SellBaseAPI.getEmailLogs({ limit: 30 }).then(function(logs2: any) {
              var body = document.getElementById('email-logs-body');
              if (!body || !Array.isArray(logs2)) return;
              var lhtml = '';
              logs2.forEach(function(l: any) {
                lhtml += '<tr><td>' + formatDateTime(l.created_at) + '</td><td>' + escapeHtml(l.recipient_email || '') + '</td><td>' + escapeHtml(l.subject || '') + '</td><td>' + (l.status === 'sent' ? '<span class="badge badge-active">Wysłano</span>' : '<span class="badge badge-inactive">Błąd</span>') + '</td><td>' + escapeHtml(l.event_type || '') + '</td></tr>';
              });
              body.innerHTML = lhtml || '<tr><td colspan="5" style="text-align:center;color:var(--color-text-muted)">Brak logów</td></tr>';
            }).catch(function() {});
          }).catch(function(err: any) { showToast(err.message || 'Błąd czyszczenia', 'error'); });
        });
      }, 50);
    });
}

/* Zdarzenia znane systemowi — opis mówi, KIEDY szablon się wyśle (pytanie właściciela 2026-09-09:
   „po dodaniu szablonu on z automatu się będzie wysyłał czy będzie uruchamiany akcją automatyczną?").
   Inny kod zdarzenia = szablon używany wyłącznie przez akcję automatyczną „Wyślij e-mail". */
var EMAIL_TPL_ZDARZENIA: Array<[string, string]> = [
  ['invoice.created', 'automatycznie po wystawieniu dokumentu sprzedaży (na e-mail kupującego)'],
  ['invoice.sent_to_erp', 'automatycznie po wysłaniu dokumentu do systemu ERP (np. wFirma)'],
  ['order.status_changed', 'automatycznie przy zmianie statusu zamówienia objętej regułą statusu'],
  ['invoice.manual', 'ręcznie — przycisk „Wyślij e-mail" na fakturze'],
  ['order.manual', 'ręcznie — wiadomość wysyłana z zamówienia']
];
/* Zdarzenia dokumentu — dla nich szablon ma filtry „tylko dla typu / serii" (ksef.ZDARZENIA_DOKUMENTU). */
var EMAIL_TPL_ZDARZENIA_DOKUMENTU = ['invoice.created', 'invoice.sent_to_erp'];
var EMAIL_TPL_TYPY_DOKUMENTU: Array<[string, string]> = [['invoice', 'Faktura'], ['oss', 'Faktura OSS'], ['wdt', 'Faktura WDT'], ['correction', 'Korekta'], ['receipt', 'Paragon']];
/* Pola podmieniane przy wysyłce (kontekst _build_email_context w core/api_misc_impl/ksef.py). */
var EMAIL_TPL_POLA: Array<[string, Array<[string, string]>]> = [
  ['Klient', [['customer.full_name', 'Imię i nazwisko'], ['customer.first_name', 'Imię'], ['customer.last_name', 'Nazwisko'], ['customer.email', 'E-mail'], ['customer.phone', 'Telefon']]],
  ['Zamówienie', [['order.number', 'Numer zamówienia'], ['order.status', 'Status'], ['order.total_gross', 'Kwota brutto'], ['order.currency', 'Waluta'], ['order.created_at', 'Data złożenia'], ['order.paid_at', 'Data opłacenia']]],
  ['Faktura', [['invoice.number', 'Numer faktury'], ['invoice.issue_date', 'Data wystawienia'], ['invoice.due_date', 'Termin płatności'], ['invoice.total_gross', 'Kwota brutto']]],
  ['Przesyłka', [['shipment.carrier', 'Przewoźnik / metoda dostawy'], ['shipment.tracking_number', 'Numer śledzenia'], ['shipment.tracking_url', 'Link śledzenia'], ['shipment.pickup_point', 'Punkt odbioru']]],
  ['Firma', [['company.name', 'Nazwa firmy'], ['company.email', 'E-mail firmy'], ['company.phone', 'Telefon firmy'], ['company.address', 'Adres firmy']]],
  ['Linki', [['links.invoice_pdf_url', 'Link do PDF faktury'], ['links.order_panel_url', 'Link do zamówienia w panelu']]]
];

/** Wersja tekstowa z HTML (gdy użytkownik jej nie wpisał): <br>/koniec bloku = nowa linia, reszta tagów wycięta. */
function _emailTplTekstZHtml(html: string): string {
  var el = document.createElement('div');
  el.innerHTML = String(html || '').replace(/<br\s*\/?>/gi, '\n').replace(/<\/(p|div|h[1-6]|li|tr)>/gi, '$&\n');
  return (el.textContent || '').replace(/\n{3,}/g, '\n\n').trim();
}

function _emailTplRozmiar(b: number): string {
  if (!b) return '';
  return b > 1024 * 1024 ? (b / 1024 / 1024).toFixed(1) + ' MB' : Math.max(1, Math.round(b / 1024)) + ' KB';
}

function openEmailTemplateModal(template: EmailTemplate | null) {
    var isEdit = !!template;
    // 2026-09-09 (prośba właściciela): edytor WYSIWYG (wspólny moduł wysiwyg.ts) zamiast gołego pola
    // HTML + załączniki szablonu (PDF faktury z AKTYWNEGO systemu fakturowania — nie „wFirma" na
    // sztywno — albo własne pliki).
    var zal: EmailTemplateAttachment[] = (template && Array.isArray(template.attachments)) ? template.attachments.filter(function(a) { return !!a && a.type === 'file'; }) : [];
    var fakturaPdf = !!(template && Array.isArray(template.attachments) && template.attachments.some(function(a) { return !!a && a.type === 'invoice_pdf'; }));
    var eventVal = template ? String(template.event_type || '') : '';
    var znane = EMAIL_TPL_ZDARZENIA.some(function(z) { return z[0] === eventVal; });
    var filtry = (template && template.filters) || {};
    var filtryTypy: string[] = Array.isArray(filtry.document_types) ? filtry.document_types.map(String) : [];
    var filtrySerie: number[] = Array.isArray(filtry.series_ids) ? filtry.series_ids.map(function(x) { return Number(x); }) : [];
    var eventOpts = EMAIL_TPL_ZDARZENIA.map(function(z) { return '<option value="' + escapeAttr(z[0]) + '"' + (z[0] === eventVal ? ' selected' : '') + '>' + escapeHtml(z[0]) + ' — ' + escapeHtml(z[1]) + '</option>'; }).join('')
      + '<option value="__custom__"' + (eventVal && !znane ? ' selected' : '') + '>inne — własny kod zdarzenia (wysyłka tylko akcją automatyczną „Wyślij e-mail")</option>';
    var body = '<form class="settings-form" id="email-template-form"><div class="form-grid">'
      + '<div class="form-group"><label>Nazwa</label><input class="form-input" name="name" value="' + escapeAttr(template ? template.name : '') + '"></div>'
      + '<div class="form-group"><label>Kod</label><input class="form-input" name="code" value="' + escapeAttr(template ? template.code : '') + '"' + (isEdit ? ' disabled' : '') + ' placeholder="np. faktura_klient"><div class="sb-tpl-hint">Ten kod wybierasz w akcji automatycznej „Wyślij e-mail"</div></div>'
      + '<div class="form-group"><label>Kiedy wysyłać (zdarzenie)</label><select class="form-select" id="email-tpl-event-sel">' + eventOpts + '</select><input class="form-input" name="event_type" id="email-tpl-event-custom" value="' + escapeAttr(eventVal) + '" placeholder="własny kod zdarzenia" style="margin-top:6px' + (eventVal && !znane ? '' : ';display:none') + '"></div>'
      + '<div class="form-group"><label>Język</label><input class="form-input" name="language" value="' + escapeAttr(template ? (template.language || 'pl') : 'pl') + '"></div>'
      // 2026-09-09 (prośba właściciela): warunki wysyłki automatycznej dla zdarzeń dokumentu —
      // „określona seria dokumentu", typ dokumentu. Puste = każdy dokument. Serie dociągane async.
      + '<div class="form-group full-width" id="email-tpl-filtry" style="' + (EMAIL_TPL_ZDARZENIA_DOKUMENTU.indexOf(eventVal) !== -1 ? '' : 'display:none') + '"><label>Wysyłaj tylko dla</label><div class="sb-tpl-filtry">'
      +   '<div><div class="sb-tpl-hint" style="margin:0 0 4px">Typ dokumentu (brak zaznaczenia = każdy)</div><div class="sb-tpl-filtry-opcje" id="email-tpl-filtr-typy">' + EMAIL_TPL_TYPY_DOKUMENTU.map(function(t) { return '<label class="sb-tpl-zal-opt"><input type="checkbox" data-doc-type="' + escapeAttr(t[0]) + '"' + (filtryTypy.indexOf(t[0]) !== -1 ? ' checked' : '') + '> <span>' + escapeHtml(t[1]) + '</span></label>'; }).join('') + '</div></div>'
      +   '<div><div class="sb-tpl-hint" style="margin:0 0 4px">Seria numeracji (brak zaznaczenia = każda)</div><div class="sb-tpl-filtry-opcje" id="email-tpl-filtr-serie"><span class="sb-tpl-hint">Ładowanie serii…</span></div></div>'
      + '</div></div>'
      + '<div class="form-group full-width"><label>Temat</label><input class="form-input" name="subject_template" value="' + escapeAttr(template ? template.subject_template : '') + '"></div>'
      + '<div class="form-group full-width"><label>Treść wiadomości</label>'
      +   '<div id="email-tpl-editor"></div>'
      +   '<div class="sb-tpl-hint">Pola w nawiasach {{…}} zostaną przy wysyłce podmienione danymi klienta, zamówienia lub faktury.</div>'
      + '</div>'
      + '<div class="form-group full-width"><label>Załączniki</label><div class="sb-tpl-zal">'
      +   '<label class="sb-tpl-zal-opt"><input type="checkbox" id="email-tpl-zal-fv"' + (fakturaPdf ? ' checked' : '') + '> <span>PDF faktury z aktywnego systemu fakturowania (SellBase, wFirma lub inny podłączony system) — gdy wiadomość dotyczy faktury albo zamówienia z wystawioną fakturą</span></label>'
      +   '<div class="sb-tpl-zal-pliki" id="email-tpl-zal-pliki"></div>'
      +   '<div class="sb-tpl-zal-akcje"><label class="btn-secondary sb-tpl-zal-btn"><i data-lucide="paperclip" style="width:14px;height:14px"></i> Dodaj własny plik<input type="file" id="email-tpl-zal-file" multiple accept=".pdf,.png,.jpg,.jpeg,.gif,.webp,.doc,.docx,.xls,.xlsx,.csv,.txt,.zip" style="display:none"></label><span class="sb-tpl-hint">pdf, obrazy, doc/docx, xls/xlsx, csv, txt, zip · max 10 MB · do 10 plików</span></div>'
      + '</div></div>'
      + '<div class="form-group full-width"><details class="sb-tpl-tekst"><summary>Wersja tekstowa (opcjonalnie — gdy pusta, powstanie automatycznie z treści)</summary><textarea class="form-textarea" name="text_template" rows="4">' + escapeHtml(template ? template.text_template : '') + '</textarea></details></div>'
      + '<div class="form-group"><label>Aktywny</label><select class="form-select" name="enabled"><option value="1"' + ((template && template.enabled) || !template ? ' selected' : '') + '>Tak</option><option value="0"' + (template && !template.enabled ? ' selected' : '') + '>Nie</option></select></div>'
      + '</div></form>';
    var footer = '<button class="btn-secondary" onclick="SellBaseApp.closeModal()">Anuluj</button><button class="btn-primary" id="email-template-save-btn">' + (isEdit ? 'Zapisz' : 'Dodaj') + '</button>';
    openModal(isEdit ? 'Edytuj szablon e-mail' : 'Nowy szablon e-mail', body, footer, true);
    setTimeout(function() {
      var form = document.getElementById('email-template-form');
      var btn = document.getElementById('email-template-save-btn');
      var edytorHost = document.getElementById('email-tpl-editor');
      var evSel = document.getElementById('email-tpl-event-sel') as HTMLSelectElement | null;
      var evCustom = document.getElementById('email-tpl-event-custom') as HTMLInputElement | null;
      var listaZal = document.getElementById('email-tpl-zal-pliki');
      var fileInp = document.getElementById('email-tpl-zal-file') as HTMLInputElement | null;
      if (!form || !btn || !edytorHost) return;
      var edytor = zamontujWysiwyg(edytorHost, { html: template ? String(template.html_template || '') : '', idPrefix: 'email-tpl', pola: EMAIL_TPL_POLA });
      var filtryBox = document.getElementById('email-tpl-filtry');
      function pokazFiltry() {
        if (!filtryBox) return;
        var ev = evCustom ? String(evCustom.value || '') : '';
        filtryBox.style.display = EMAIL_TPL_ZDARZENIA_DOKUMENTU.indexOf(ev) !== -1 ? '' : 'none';
      }
      if (evSel && evCustom) {
        if (evSel.value !== '__custom__') evCustom.value = evSel.value;
        evSel.addEventListener('change', function() {
          var custom = evSel!.value === '__custom__';
          evCustom!.style.display = custom ? '' : 'none';
          evCustom!.value = custom ? '' : evSel!.value;
          if (custom) evCustom!.focus();
          pokazFiltry();
        });
        evCustom.addEventListener('input', pokazFiltry);
      }
      // serie numeracji do filtra (async, best-effort)
      (function() {
        var host = document.getElementById('email-tpl-filtr-serie');
        if (!host) return;
        Promise.resolve(SellBaseAPI.getInvoiceSeries()).then(function(serie: any) {
          var lista = (Array.isArray(serie) ? serie : []).filter(function(x: any) { return x && (x.is_active === undefined || x.is_active); });
          host!.innerHTML = lista.length ? lista.map(function(x: any) {
            return '<label class="sb-tpl-zal-opt"><input type="checkbox" data-series-id="' + escapeAttr(String(x.id)) + '"' + (filtrySerie.indexOf(Number(x.id)) !== -1 ? ' checked' : '') + '> <span>' + escapeHtml(x.name || x.prefix || ('#' + x.id)) + (x.prefix ? ' <span style="color:var(--color-text-muted)">(' + escapeHtml(x.prefix) + ')</span>' : '') + '</span></label>';
          }).join('') : '<span class="sb-tpl-hint">Brak serii numeracji</span>';
        }).catch(function() { host!.innerHTML = '<span class="sb-tpl-hint">Nie udało się pobrać serii</span>'; });
      })();
      function rysujZal() {
        if (!listaZal) return;
        listaZal.innerHTML = zal.length ? zal.map(function(z, i) {
          return '<div class="sb-tpl-zal-plik"><i data-lucide="file" style="width:14px;height:14px"></i><span class="sb-tpl-zal-nazwa" title="' + escapeAttr(z.name || z.path || '') + '">' + escapeHtml(z.name || z.path || '') + '</span><span class="sb-tpl-zal-rozmiar">' + escapeHtml(_emailTplRozmiar(z.size || 0)) + '</span><button type="button" class="action-btn" data-zal-usun="' + i + '" aria-label="Usuń załącznik" title="Usuń z szablonu"><i data-lucide="x" style="width:14px;height:14px"></i></button></div>';
        }).join('') : '<div class="sb-tpl-zal-brak">Brak własnych plików</div>';
        listaZal.querySelectorAll('[data-zal-usun]').forEach(function(b: any) {
          b.addEventListener('click', function(this: any) { zal.splice(parseInt(this.dataset.zalUsun, 10), 1); rysujZal(); });
        });
        if ((window as any).lucide && (window as any).lucide.createIcons) (window as any).lucide.createIcons();
      }
      rysujZal();
      if (fileInp) fileInp.addEventListener('change', async function() {
        var pliki: File[] = Array.prototype.slice.call(fileInp!.files || []);
        fileInp!.value = '';
        var tok = ((window as any).SellBaseAPI && (window as any).SellBaseAPI.getAuthToken) ? (window as any).SellBaseAPI.getAuthToken() : '';
        for (var k = 0; k < pliki.length; k++) {
          if (zal.length >= 10) { showToast('Maksymalnie 10 własnych plików', 'error'); break; }
          var f = pliki[k];
          if (f.size > 10 * 1024 * 1024) { showToast(f.name + ': plik za duży (max 10 MB)', 'error'); continue; }
          var fd = new FormData(); fd.append('file', f, f.name);
          try {
            var r = await fetch('/api/email/attachments/upload', { method: 'POST', headers: { Authorization: 'Bearer ' + tok }, body: fd });
            if (!r.ok) { var msg = 'HTTP ' + r.status; try { msg = (await r.json()).detail || msg; } catch { /* noop */ } throw new Error(msg); }
            var d = await r.json();
            zal.push({ type: 'file', path: String(d.path || ''), name: String(d.name || f.name), mime: String(d.mime || f.type || ''), size: Number(d.size || f.size || 0) });
            rysujZal();
          } catch (e: any) { showToast('Nie udało się dodać pliku: ' + (e && e.message ? e.message : e), 'error'); }
        }
      });
      btn.addEventListener('click', function(this: any) {
        var html = edytor.pobierzHtml();
        var text = String((form!.querySelector('[name="text_template"]') as any)?.value || '').trim();
        var attachments: EmailTemplateAttachment[] = [];
        if ((document.getElementById('email-tpl-zal-fv') as HTMLInputElement | null)?.checked) attachments.push({ type: 'invoice_pdf' });
        attachments = attachments.concat(zal);
        var payload = {
          name: (form!.querySelector('[name="name"]') as any)?.value.trim(),
          code: (form!.querySelector('[name="code"]') as any)?.value.trim(),
          event_type: String(evCustom ? evCustom.value : '').trim(),
          language: (form!.querySelector('[name="language"]') as any)?.value.trim() || 'pl',
          subject_template: (form!.querySelector('[name="subject_template"]') as any)?.value,
          html_template: html,
          text_template: text || _emailTplTekstZHtml(html),
          enabled: parseInt((form!.querySelector('[name="enabled"]') as any)?.value, 10),
          attachments: attachments,
          filters: {
            document_types: Array.prototype.slice.call(document.querySelectorAll('#email-tpl-filtr-typy input:checked')).map(function(c: any) { return String(c.dataset.docType); }),
            series_ids: Array.prototype.slice.call(document.querySelectorAll('#email-tpl-filtr-serie input:checked')).map(function(c: any) { return parseInt(c.dataset.seriesId, 10); })
          }
        } as any;
        if (!payload.name || !payload.code || !payload.event_type) { showToast('Podaj nazwę, kod i zdarzenie', 'error'); return; }
        var req = isEdit ? SellBaseAPI.updateEmailTemplate(template!.id, payload) : SellBaseAPI.createEmailTemplate(payload);
        req.then(function() {
          closeModal();
          showToast('Szablon zapisany', 'success');
          // S-139: tylko tabela szablonów — formularz SMTP i historia wysyłek pod
          // spodem zostają nietknięte (bez renderEmailTab()).
          _odswiezTabeleSzablonowEmail();
        }).catch(function(err: any) { showToast(err.message || 'Błąd zapisu szablonu', 'error'); });
      });
      if ((window as any).lucide && (window as any).lucide.createIcons) (window as any).lucide.createIcons();
    }, 50);
}

/* -----------------------------------------------
     Settings — Updates Tab
     ----------------------------------------------- */
function canManageAsystentAi() {
    var _u: any = $currentUser.get();
    var _rola = _u && _u.role && _u.role.name;
    // Decyzja właściciela (plan v2, 26.10): zakładkę i propozycje asystenta widzi tylko właściciel firmy.
    return !!(_u && (_rola === 'owner' || _rola === 'master_admin' || _u.is_master));
}

function canManageUpdates() {
    var _u: any = $currentUser.get();
    // `/api/admin/updates/*` zarządza GLOBALNYM changelogiem wszystkich firm i
    // backend wymaga master_admin również do odczytu. Uprawnienie settings:read
    // nie może więc ujawniać tej zakładki ani jej przycisków.
    return !!(_u && (_u.is_master || (_u.role && _u.role.name === 'master_admin')));
}

function renderUpdateTypeLabel(type: string) {
    return updateTypeMeta(type).label;
}

// S-139: jeden wiersz wpisu aktualności — wyodrębnione, żeby po publikacji/
// przypięciu/usunięciu dało się zmienić TYLKO ten wiersz, bez przeładowania
// całej zakładki (200 wpisów, spinner, skok na górę).
function _updateRowHtml(item: any): string {
    var statusBadge = item.is_published ? '<span class="badge badge-active">Opublikowany</span>' : '<span class="badge badge-inactive">Szkic</span>';
    var pinnedBadge = item.is_pinned ? '<span class="badge badge-default">Tak</span>' : '<span class="badge">Nie</span>';
    var typeMeta = updateTypeMeta(item.type);
    return '<tr data-update-row="' + item.id + '">' +
      '<td><span class="badge" style="background:' + typeMeta.color + ';color:#fff">' + escapeHtml(renderUpdateTypeLabel(item.type)) + '</span></td>' +
      '<td style="font-weight:500">' + escapeHtml(item.title || '') + '</td>' +
      '<td class="upd-status-cell">' + statusBadge + '</td>' +
      '<td class="upd-pinned-cell">' + pinnedBadge + '</td>' +
      '<td>' + (item.published_at ? formatDateTime(item.published_at) : '—') + '</td>' +
      '<td>' + escapeHtml(item.author_name || '—') + '</td>' +
      '<td><div class="table-actions">' +
        (canManageUpdates() ? '<button class="action-btn" data-action="edit-update" data-id="' + item.id + '" aria-label="Edytuj"><i data-lucide="pencil" style="width:14px;height:14px"></i></button>' : '') +
        (canManageUpdates() ? (
          (item.is_published
            ? '<button class="action-btn" data-action="unpublish-update" data-id="' + item.id + '" aria-label="Ukryj"><i data-lucide="eye-off" style="width:14px;height:14px"></i></button>'
            : '<button class="action-btn" data-action="publish-update" data-id="' + item.id + '" aria-label="Publikuj"><i data-lucide="eye" style="width:14px;height:14px"></i></button>') +
          (item.is_pinned
            ? '<button class="action-btn" data-action="unpin-update" data-id="' + item.id + '" aria-label="Odepnij"><i data-lucide="pin-off" style="width:14px;height:14px"></i></button>'
            : '<button class="action-btn" data-action="pin-update" data-id="' + item.id + '" aria-label="Przypnij"><i data-lucide="pin" style="width:14px;height:14px"></i></button>') +
          '<button class="action-btn" data-action="delete-update" data-id="' + item.id + '" aria-label="Usuń"><i data-lucide="trash-2" style="width:14px;height:14px"></i></button>'
        ) : '') +
      '</div></td>' +
    '</tr>';
}

async function renderUpdatesTab(cicho?: boolean) {
    var panel = document.getElementById('panel-updates');
    if (!panel) return;
    // S-139 przegląd: odpięcie wpisu woła to w trybie cichym (bez punktu zaczepienia
    // do poprawnego przesunięcia wiersza) — bez tego warunku user widziałby mignięcie „Ładowanie…”.
    if (!cicho) panel.innerHTML = '<div class="settings-card"><div style="padding:var(--space-5)">Ładowanie wpisów aktualizacji...</div></div>';
    try {
      var updates = await SellBaseAPI.getAdminUpdates({ limit: 200 });
      $adminUpdatesList.set(Array.isArray(updates) ? updates : []);
      var html =
        '<div class="settings-card">' +
          '<div class="settings-card-header">' +
            '<div><div class="settings-card-title">Aktualizacje systemu</div>' +
            '<div class="settings-card-subtitle">Zarządzaj changelogiem widocznym na dashboardzie</div></div>' +
            (canManageUpdates()
              ? '<button class="btn-primary" id="add-update-btn"><i data-lucide="plus" style="width:15px;height:15px"></i> Dodaj wpis</button>'
              : '') +
          '</div>' +
          '<div class="table-scroll">' +
            '<table class="data-table">' +
              '<thead><tr><th>Typ</th><th>Tytuł</th><th>Status</th><th>Przypięty</th><th>Publikacja</th><th>Autor</th><th>Akcje</th></tr></thead>' +
              '<tbody>';

      ($adminUpdatesList.get() || []).forEach(function(item: any) { html += _updateRowHtml(item); });
      if (!($adminUpdatesList.get() || []).length) {
        html += '<tr id="updates-empty-row"><td colspan="7" style="text-align:center;color:var(--color-text-muted);padding:var(--space-6)">Brak wpisów aktualizacji.</td></tr>';
      }
      html += '</tbody></table></div></div>';
      panel.innerHTML = html;

      var addBtn = document.getElementById('add-update-btn');
      if (addBtn) addBtn.addEventListener('click', function(this: any) { openUpdateModal(null); });

      // S-139: jeden delegowany listener na panelu — po zmianie wpisu podmieniamy
      // TYLKO jego wiersz (_updateRowHtml), więc stare bindy per-przycisk by
      // przepadały; delegacja łapie kliki także na świeżo podmienionych wierszach.
      if (!(panel as any)._updActionsBound) {
        (panel as any)._updActionsBound = true;
        panel.addEventListener('click', function(ev: any) {
          var btn = ev.target && ev.target.closest ? ev.target.closest('[data-action]') : null;
          if (!btn) return;
          var action = String(btn.dataset.action || '');
          var id = parseInt(btn.dataset.id, 10);
          var wiersz = btn.closest('tr');
          var lista = $adminUpdatesList.get() || [];
          var item = lista.find(function(x: any) { return x.id === id; });

          if (action === 'edit-update') { openUpdateModal(id); return; }

          if (action === 'publish-update' || action === 'unpublish-update') {
            var wPublikuj = action === 'publish-update';
            var fn = wPublikuj ? SellBaseAPI.publishAdminUpdate : SellBaseAPI.unpublishAdminUpdate;
            fn(id).then(function() {
              showToast(wPublikuj ? 'Wpis opublikowany' : 'Wpis ukryty', 'success');
              if (item) { item.is_published = wPublikuj; item.published_at = wPublikuj ? (item.published_at || new Date().toISOString()) : item.published_at; }
              if (wiersz && item) podmienElement(wiersz, _updateRowHtml(item));
            }).catch(function(err: any) { showToast(err.message || 'Błąd publikacji', 'error'); });
            return;
          }
          if (action === 'pin-update' || action === 'unpin-update') {
            var wPin = action === 'pin-update';
            var fnP = wPin ? SellBaseAPI.pinAdminUpdate : SellBaseAPI.unpinAdminUpdate;
            fnP(id).then(async function() {
              showToast(wPin ? 'Wpis przypięty' : 'Wpis odpięty', 'success');
              if (item) item.is_pinned = wPin;
              if (wPin) {
                if (wiersz && item) {
                  var nowy = podmienElement(wiersz, _updateRowHtml(item));
                  // Przypięte wpisy idą na górę listy — jak w dashboardzie.
                  if (nowy && nowy.parentElement && nowy.parentElement.firstElementChild !== nowy) {
                    nowy.parentElement.insertBefore(nowy, nowy.parentElement.firstElementChild);
                  }
                }
                return;
              }
              // S-139 przegląd: odpięcie nie ma punktowego odwrotnego ruchu — gdzie
              // wiersz ma wrócić zależy od sortowania reszty listy na serwerze (data,
              // inne przypięte). Zgadywanie lokalnie groziłoby złą kolejnością, więc
              // pełny cichy render ze scrollem zachowanym (panel ma być aktualny).
              var _przywrocUpd = zapamietajWidok(panel);
              await renderUpdatesTab(true);
              _przywrocUpd();
            }).catch(function(err: any) { showToast(err.message || 'Błąd przypinania', 'error'); });
            return;
          }
          if (action === 'delete-update') {
            var body = '<p>Czy na pewno chcesz usunąć ten wpis aktualizacji?</p>';
            var footer = '<button class="btn-secondary" onclick="SellBaseApp.closeModal()">Anuluj</button>' +
              '<button class="btn-sm danger" id="confirm-delete-update" style="height:36px;padding:var(--space-2) var(--space-4);">Usuń</button>';
            openModal('Usuń wpis', body, footer);
            setTimeout(function() {
              var confirmBtn = document.getElementById('confirm-delete-update');
              if (!confirmBtn) return;
              confirmBtn.addEventListener('click', function() {
                SellBaseAPI.deleteAdminUpdate(id).then(function() {
                  closeModal();
                  showToast('Wpis usunięty', 'success');
                  $adminUpdatesList.set(lista.filter(function(x: any) { return x.id !== id; }));
                  if (wiersz) {
                    // S-139 przegląd: poUsunieciu woła się PO wiersz.remove() — parentElement
                    // jest już null. Zapamiętaj tbody PRZED wygaszeniem, inaczej pusty stan
                    // nigdy się nie pojawia po usunięciu ostatniego wpisu.
                    var tbodyAktualnosci = wiersz.parentElement;
                    wygasIUsun(wiersz, { poUsunieciu: function () {
                      if (tbodyAktualnosci && !tbodyAktualnosci.querySelector('[data-update-row]')) {
                        tbodyAktualnosci.innerHTML = '<tr id="updates-empty-row"><td colspan="7" style="text-align:center;color:var(--color-text-muted);padding:var(--space-6)">Brak wpisów aktualizacji.</td></tr>';
                      }
                    } });
                  }
                }).catch(function(err: any) { showToast(err.message || 'Błąd usuwania', 'error'); });
              });
            }, 50);
          }
        });
      }

      lucide.createIcons();
    } catch (e: any) {
      panel.innerHTML =
        '<div class="settings-card" style="border-left:3px solid var(--color-error)">' +
          '<div style="padding:var(--space-5)">' +
            '<div style="font-weight:600;color:var(--color-error);margin-bottom:var(--space-2)">Nie udało się pobrać wpisów aktualizacji</div>' +
            '<div style="font-size:var(--text-sm);color:var(--color-text-muted)">' + escapeHtml(e.message || 'Błąd API') + '</div>' +
          '</div>' +
        '</div>';
    }
}

function openUpdateModal(updateId: number | string | null) {
    var isEdit = !!updateId;
    if (isEdit && !canManageUpdates()) return;

    var item = null;
    if (isEdit) {
      var _adminList = $adminUpdatesList.get() || [];
      for (var i = 0; i < _adminList.length; i++) {
        if (_adminList[i].id === updateId) { item = _adminList[i]; break; }
      }
      if (!item) return;
    }

    var body = '<form class="settings-form" id="update-form">' +
      '<div class="form-grid">' +
        '<div class="form-group full-width"><label>Tytuł</label><input class="form-input" name="title" value="' + escapeAttr(item ? item.title : '') + '"></div>' +
        '<div class="form-group"><label>Typ</label><select class="form-select" name="type">' +
          '<option value="feature"' + ((item && item.type === 'feature') || !item ? ' selected' : '') + '>Nowa funkcja</option>' +
          '<option value="improvement"' + (item && item.type === 'improvement' ? ' selected' : '') + '>Usprawnienie</option>' +
          '<option value="fix"' + (item && item.type === 'fix' ? ' selected' : '') + '>Poprawka</option>' +
          '<option value="technical"' + (item && item.type === 'technical' ? ' selected' : '') + '>Techniczne</option>' +
        '</select></div>' +
        '<div class="form-group"><label>Slug</label><input class="form-input" name="slug" value="' + escapeAttr(item ? item.slug : '') + '"></div>' +
        '<div class="form-group full-width"><label>Krótki opis</label><textarea class="form-textarea" name="summary" rows="3">' + escapeHtml(item ? item.summary : '') + '</textarea></div>' +
        '<div class="form-group full-width"><label>Pełna treść</label><textarea class="form-textarea" name="content" rows="8">' + escapeHtml(item ? item.content : '') + '</textarea></div>' +
        '<div class="form-group"><label>Moduł</label><input class="form-input" name="module_key" value="' + escapeAttr(item ? item.module_key : '') + '" placeholder="orders / shipping / invoices"></div>' +
        '<div class="form-group"><label>Wersja</label><input class="form-input" name="version_label" value="' + escapeAttr(item ? item.version_label : '') + '" placeholder="np. v0.9.3"></div>' +
        '<div class="form-group"><label>Grupa odbiorców</label><select class="form-select" name="audience">' +
          '<option value="all"' + ((item && item.audience === 'all') || !item ? ' selected' : '') + '>Wszyscy</option>' +
          '<option value="admin"' + (item && item.audience === 'admin' ? ' selected' : '') + '>Admin</option>' +
          '<option value="manager"' + (item && item.audience === 'manager' ? ' selected' : '') + '>Manager</option>' +
          '<option value="operator"' + (item && item.audience === 'operator' ? ' selected' : '') + '>Operator</option>' +
          '<option value="viewer"' + (item && item.audience === 'viewer' ? ' selected' : '') + '>Viewer</option>' +
        '</select></div>' +
        '<div class="form-group"><label>Opublikowany</label><select class="form-select" name="is_published"><option value="1"' + (item && item.is_published ? ' selected' : '') + '>Tak</option><option value="0"' + ((!item || !item.is_published) ? ' selected' : '') + '>Nie</option></select></div>' +
        '<div class="form-group"><label>Przypięty</label><select class="form-select" name="is_pinned"><option value="1"' + (item && item.is_pinned ? ' selected' : '') + '>Tak</option><option value="0"' + ((!item || !item.is_pinned) ? ' selected' : '') + '>Nie</option></select></div>' +
      '</div>' +
    '</form>';

    var footer = '<button class="btn-secondary" onclick="SellBaseApp.closeSettingsDrawer()">Anuluj</button>' +
      '<button class="btn-primary" id="save-update-btn">' + (isEdit ? 'Zapisz zmiany' : 'Dodaj wpis') + '</button>';
    openSettingsDrawer(isEdit ? 'Edytuj aktualizację' : 'Dodaj aktualizację', body, footer);

    setTimeout(function() {
      var btn = document.getElementById('save-update-btn');
      if (!btn) return;
      btn.addEventListener('click', function(this: any) {
        var form = document.getElementById('update-form');
        var payload = {
          title: (form?.querySelector('[name="title"]') as any)?.value.trim(),
          type: (form?.querySelector('[name="type"]') as any)?.value,
          slug: (form?.querySelector('[name="slug"]') as any)?.value.trim(),
          summary: (form?.querySelector('[name="summary"]') as any)?.value.trim(),
          content: (form?.querySelector('[name="content"]') as any)?.value.trim(),
          module_key: (form?.querySelector('[name="module_key"]') as any)?.value.trim(),
          version_label: (form?.querySelector('[name="version_label"]') as any)?.value.trim(),
          audience: (form?.querySelector('[name="audience"]') as any)?.value,
          is_published: parseInt((form?.querySelector('[name="is_published"]') as any)?.value, 10),
          is_pinned: parseInt((form?.querySelector('[name="is_pinned"]') as any)?.value, 10)
        } as any;
        if (!payload.title || !payload.summary) {
          showToast('Tytuł i krótki opis są wymagane', 'error');
          return;
        }
        var req = isEdit ? SellBaseAPI.updateAdminUpdate(updateId, payload) : SellBaseAPI.createAdminUpdate(payload);
        req.then(function() {
          closeSettingsDrawer();
          showToast('Wpis zapisany', 'success');
          renderUpdatesTab();
          if (state.currentView === 'dashboard') {
            $dashboardUpdatesLimit.set(5);
            renderDashboardUpdates();
          }
        }).catch(function(err: any) { showToast(err.message || 'Błąd zapisu', 'error'); });
      });
    }, 50);
}

// Faza C.3.automations — automations (1932 linii) extracted to src/modules/automations.js
function canManageUsers() {
    // 2026-07-16: gate po EFEKTYWNYM uprawnieniu (grupa Administracja = settings:write),
    // nie po twardej nazwie roli. Dzięki temu rola custom z admin:write też zarządza userami,
    // a zmiana nazwy roli admina nie wywala zarządzania. master_admin zawsze.
    var _u = $currentUser.get();
    if (!_u) return false;
    if (_u.role && _u.role.name === 'master_admin') return true;
    var p = _u.permissions || {};
    return p.settings === 'write' || p.admin === 'write';
}

function currentRoleName() {
    var u = $currentUser.get();
    return String(u && u.role && u.role.name || '').toLowerCase();
}

function canManageOwnerAccounts() {
    var role = currentRoleName();
    return role === 'owner' || role === 'master_admin';
}

function isOwnerUser(user: any) {
    return String(user && user.role && user.role.name || '').toLowerCase() === 'owner';
}

function canMutateUser(user: any) {
    return canManageUsers() && (!isOwnerUser(user) || canManageOwnerAccounts());
}

function canAssignRole(role: any) {
    var name = String(role && role.name || '').toLowerCase();
    if (name === 'master_admin') return currentRoleName() === 'master_admin';
    if (name === 'owner') return canManageOwnerAccounts();
    return true;
}

function roleDisplayName(roleName: string) {
    var map: Record<string, string> = {
      owner: 'Właściciel', admin: 'Administrator', manager: 'Manager', operator: 'Operator', viewer: 'Viewer',
      accountant_reports: 'Księgowość — odczyt i raporty', ksiegowy: 'Księgowy', pakowacz: 'Pakowacz', master_admin: 'Master Admin',
    };
    var key = String(roleName || '').toLowerCase();
    return map[key] || (roleName ? (roleName.charAt(0).toUpperCase() + roleName.slice(1)) : '—');
}

// 2026-08-25: wybrany widok tabeli userów przeżywa re-render po akcjach
// (przywrócenie/usunięcie nie może wyrzucać z widoku archiwum).
var _usersView: string = 'active';

// S-139: `cicho` = „najpierw pobierz, potem podmień" (po zapisie/akcji w tej
// zakładce) — bez spinnera i bez skoku na górę. Pierwsze wejście w zakładkę
// (brak opts) zostaje jak było: spinner widoczny od razu.
async function renderUsersTab(opts?: { cicho?: boolean }) {
    var panel = document.getElementById('panel-users');
    if (!panel) return;
    var cicho = !!(opts && opts.cicho);
    var zapScrollY = cicho ? window.scrollY : 0;
    var zapPanelScroll = cicho ? panel.scrollTop : 0;

    if (!cicho) panel.innerHTML = '<div class="settings-card"><div style="padding:var(--space-5)">Ładowanie użytkowników...</div></div>';

    try {
      var results = await Promise.all([SellBaseAPI.getRoles(), SellBaseAPI.getUsers()]);
      $rolesList.set(Array.isArray(results[0]) ? results[0] : []);
      $usersList.set(Array.isArray(results[1]) ? results[1] : []);

      // 2026-07-09 ZGŁOSZENIA BRAKÓW: parowanie kont Telegram↔SellBase (best-effort —
      // brak uprawnień/moduł wyłączony nie psuje listy użytkowników)
      var tgLinks: any = {};
      try {
        var _tgTok = ((window as any).SellBaseAPI && (window as any).SellBaseAPI.getAuthToken) ? (window as any).SellBaseAPI.getAuthToken() : '';
        var _tgResp = await fetch('/api/telegram/links', { headers: { Authorization: 'Bearer ' + _tgTok } });
        if (_tgResp.ok) { var _tgData = await _tgResp.json(); tgLinks = (_tgData && _tgData.links) || {}; }
      } catch (_eTg) { /* kolumna pokaże „Połącz" */ }

      // 2026-08-25: dwa widoki jednej tabeli — Aktywni | Zarchiwizowani
      // (przełącznik w nagłówku karty; wybór trzyma zmienna modułu, żeby
      // re-render po akcji nie wyrzucał z archiwum).
      var _activeUsers: any[] = [];
      var _archivedUsers: any[] = [];
      ($usersList.get() || []).forEach(function(user: any) {
        if (user.status === 'archived') { _archivedUsers.push(user); }
        else { _activeUsers.push(user); }
      });
      var _inArchive = _usersView === 'archived';

      var html =
        '<div class="settings-card">' +
          '<div class="settings-card-header">' +
            '<div><div class="settings-card-title">Użytkownicy</div>' +
            '<div class="settings-card-subtitle">Zarządzaj dostępem do panelu</div></div>' +
            '<div style="display:flex;align-items:center;gap:10px">' +
              '<div class="users-seg" role="tablist">' +
                '<button class="users-seg-btn' + (!_inArchive ? ' users-seg-btn--on' : '') + '" data-users-view="active">Aktywni (' + _activeUsers.length + ')</button>' +
                '<button class="users-seg-btn' + (_inArchive ? ' users-seg-btn--on' : '') + '" data-users-view="archived">Zarchiwizowani (' + _archivedUsers.length + ')</button>' +
              '</div>' +
              (canManageUsers() && !_inArchive ?
                '<button class="btn-primary" id="add-user-btn"><i data-lucide="plus" style="width:15px;height:15px"></i> Dodaj użytkownika</button>' :
                '') +
            '</div>' +
          '</div>';

      if (_inArchive) {
        if (!_archivedUsers.length) {
          html += '<div style="padding:26px;text-align:center;color:var(--color-text-muted);font-size:var(--text-sm)">Brak zarchiwizowanych użytkowników</div>';
        } else {
          html += '<div class="table-scroll"><table class="data-table"><thead><tr>' +
            '<th>Imię i nazwisko</th><th>Email</th><th>Rola</th><th>Zarchiwizowany</th><th>Akcje</th>' +
          '</tr></thead><tbody>';
          _archivedUsers.forEach(function(user: any) {
            html += '<tr style="opacity:.78">' +
              '<td>' + escapeHtml(((user.first_name || '') + ' ' + (user.last_name || '')).trim() || '—') + '</td>' +
              '<td>' + escapeHtml(user.email || '') + '</td>' +
              '<td><span class="badge badge-role">' + escapeHtml(roleDisplayName(user.role && user.role.name)) + '</span></td>' +
              '<td>' + (user.archived_at ? formatDateTime(user.archived_at) : '—') + '</td>' +
              '<td><div class="table-actions">' +
                (canMutateUser(user) ?
                  '<button class="action-btn" data-action="restore-user" data-id="' + user.id + '" aria-label="Przywróć" title="Przywróć do zespołu"><i data-lucide="rotate-ccw" style="width:14px;height:14px"></i></button>' : '') +
                (canManageOwnerAccounts() ?
                  '<button class="action-btn" data-action="perm-delete-user" data-id="' + user.id + '" aria-label="Usuń definitywnie" title="Usuń definitywnie" style="color:var(--color-error,#ef4444)"><i data-lucide="trash-2" style="width:14px;height:14px"></i></button>' : '') +
              '</div></td>' +
            '</tr>';
          });
          html += '</tbody></table></div>';
        }
        html += '</div>';
      } else {

      html +=
          '<div class="table-scroll">' +
            '<table class="data-table tbl-karty">' + // S-160 (MOB-6): użytkownik jako karta na telefonie
              '<thead><tr>' +
                '<th>Imię</th>' +
                '<th>Nazwisko</th>' +
                '<th>Email</th>' +
                '<th>Rola</th>' +
                '<th>Telegram</th>' +
                '<th>Data utworzenia</th>' +
                '<th>Akcje</th>' +
              '</tr></thead>' +
              '<tbody>';

      _activeUsers.forEach(function(user: any) {

        // Telegram: sparowany → zielony badge @username + rozłącz; brak → przycisk parowania
        var _tgl = tgLinks[String(user.id)];
        var tgCell;
        if (_tgl) {
          tgCell = '<span style="display:inline-flex;align-items:center;gap:5px;font-size:11.5px;color:#22c55e" title="Sparowano: ' + escapeAttr(_tgl.name || '') + '">' +
            '<i data-lucide="message-circle" style="width:12px;height:12px"></i>' +
            escapeHtml(_tgl.username ? '@' + _tgl.username : (_tgl.name || 'połączony')) + '</span>' +
            (canMutateUser(user) ? ' <button class="action-btn" data-action="tg-unlink" data-id="' + user.id + '" aria-label="Rozłącz Telegram" title="Rozłącz" style="color:var(--color-text-muted)"><i data-lucide="unlink" style="width:12px;height:12px"></i></button>' : '');
        } else if (canMutateUser(user)) {
          tgCell = '<button class="btn-secondary" data-action="tg-link" data-id="' + user.id + '" data-name="' + escapeAttr(((user.first_name || '') + ' ' + (user.last_name || '')).trim() || user.email || '') + '" style="font-size:11px;padding:3px 10px">Połącz</button>';
        } else {
          tgCell = '<span style="color:var(--color-text-muted);font-size:var(--text-xs)">—</span>';
        }

        html += '<tr>' +
          '<td>' + escapeHtml(user.first_name || '') + '</td>' +
          '<td>' + escapeHtml(user.last_name || '') + '</td>' +
          '<td>' + escapeHtml(user.email || '') + '</td>' +
          '<td><span class="badge badge-role">' + escapeHtml(roleDisplayName(user.role && user.role.name)) + '</span>' +
          // 2026-10-26 E1: konto „Asystent AI” (Grok Bot) — widoczne, żeby właściciel mógł je zablokować
          ((user as any).rodzaj_konta === 'agent' ? '<span class="aai-plakietka-agent" title="Konto asystenta AI — nie loguje się do panelu, działa kluczem API">Agent AI</span>' : '') +
          '</td>' +
          '<td>' + tgCell + '</td>' +
          '<td>' + formatDateTime(user.created_at) + '</td>' +
          '<td><div class="table-actions">' +
            (canMutateUser(user) ?
              '<button class="action-btn" data-action="edit-user" data-id="' + user.id + '" aria-label="Edytuj"><i data-lucide="pencil" style="width:14px;height:14px"></i></button>' +
              (!isOwnerUser(user) ? '<button class="action-btn" data-action="archive-user" data-id="' + user.id + '" aria-label="Archiwizuj" title="Archiwizuj (były pracownik)"><i data-lucide="archive" style="width:14px;height:14px"></i></button>' : '') :
              (isOwnerUser(user) ?
                '<span title="Konto właściciela jest chronione" style="display:inline-flex;align-items:center;gap:5px;color:var(--color-text-muted);font-size:var(--text-xs)"><i data-lucide="shield-check" style="width:13px;height:13px"></i> Chronione</span>' :
                '<span style="color:var(--color-text-muted);font-size:var(--text-xs)">Brak</span>')) +
          '</div></td>' +
        '</tr>';
      });

      html += '</tbody></table></div></div>';
      }

      html += '<div class="settings-card">' +
        '<div class="settings-card-header">' +
          '<div><div class="settings-card-title">Role</div>' +
          '<div class="settings-card-subtitle">Dostępne role w systemie</div></div>' +
          (canManageUsers() ? '<button class="btn-secondary" id="add-role-btn"><i data-lucide="plus" style="width:15px;height:15px"></i> Dodaj rolę</button>' : '') +
        '</div>' +
        '<div class="roles-grid">';

      ($rolesList.get() || []).forEach(function(role: any) {
        if (role.name === 'master_admin') return; // Ukryj master_admin
        var perms = role.permissions || {};
        var allDashboardKeys = allDashboardWidgetKeys();
        var dashboardVisible = Array.isArray(role.dashboard_visible_widgets)
          ? role.dashboard_visible_widgets.filter(function(key: string) { return allDashboardKeys.indexOf(key) !== -1; })
          : ((perms.analytics === 'read' || perms.analytics === 'write') ? allDashboardKeys.slice() : []);
        var dashboardEnabled = typeof role.dashboard_enabled === 'boolean'
          ? role.dashboard_enabled
          : dashboardVisible.length > 0;
        var dashboardSummary = !dashboardEnabled
          ? 'Dashboard: wyłączony'
          : (dashboardVisible.length === allDashboardKeys.length
            ? 'Dashboard: włączony — wszystkie elementy'
            : 'Dashboard: włączony — ' + dashboardVisible.length + ' z ' + allDashboardKeys.length);
        var permBadges = '<div style="margin-top:8px;display:flex;flex-wrap:wrap;gap:3px">';
        MODULE_DEFS.forEach(function(m: ModuleDef) {
          var val = perms[m.key] || 'none';
          var icon, color, tip;
          if (val === 'write') { icon = 'check-circle'; color = '#22c55e'; tip = 'Odczyt+Zapis'; }
          else if (val === 'read') { icon = 'eye'; color = '#f59e0b'; tip = 'Tylko odczyt'; }
          else { icon = 'x-circle'; color = '#ef4444'; tip = 'Brak dostępu'; }
          permBadges += '<span title="' + escapeAttr(m.label + ': ' + tip) + '" style="display:inline-flex;align-items:center;gap:2px;padding:1px 6px;border-radius:4px;font-size:10px;background:rgba(' + (val === 'write' ? '34,197,94' : val === 'read' ? '245,158,11' : '239,68,68') + ',.1);color:' + color + '">' +
            '<i data-lucide="' + icon + '" style="width:10px;height:10px"></i> ' + escapeHtml(m.label) + '</span>';
        });
        permBadges += '</div>';
        var actionBtns = '';
        if (canManageUsers()) {
          actionBtns += '<button class="action-btn accounting-role-btn" data-role-id="' + role.id + '" aria-label="Wybierz raporty księgowe" title="Raporty księgowe"><i data-lucide="files" style="width:14px;height:14px"></i></button>';
          actionBtns += '<button class="action-btn dashboard-role-btn" data-role-id="' + role.id + '" aria-label="Ustaw elementy Dashboardu" title="Elementy Dashboardu"><i data-lucide="layout-dashboard" style="width:14px;height:14px"></i></button>';
          if (role.name !== 'owner') {
            // Edycja — dla wszystkich (systemowe edytują tylko permissions, niesystemowe pełną edycję)
            actionBtns += '<button class="action-btn edit-role-btn" data-role-id="' + role.id + '" aria-label="Edytuj uprawnienia"><i data-lucide="pencil" style="width:14px;height:14px"></i></button>';
            // Usuń — TYLKO dla niesystemowych
            if (!role.is_system) {
              actionBtns += '<button class="action-btn delete-role-btn" data-role-id="' + role.id + '" data-role-name="' + escapeAttr(role.name) + '" aria-label="Usuń rolę" style="color:var(--color-error,#ef4444)"><i data-lucide="trash-2" style="width:14px;height:14px"></i></button>';
            }
          }
        }
        var actionsHtml = actionBtns
          ? '<div style="position:absolute;top:8px;right:8px;display:flex;gap:4px">' + actionBtns + '</div>'
          : '';
        html += '<div class="role-info-card" style="position:relative">' +
          actionsHtml +
          '<div class="role-info-title" style="padding-right:' + (actionBtns ? '140px' : '0') + '">' + escapeHtml(roleDisplayName(role.name)) +
          (role.is_system ? ' <span style="font-size:10px;color:var(--color-text-muted)">(systemowa)</span>' : '') +
          '</div>' +
          '<div class="settings-card-subtitle">' + escapeHtml(role.description || '') + '</div>' +
          '<div style="margin-top:9px;display:inline-flex;align-items:center;gap:6px;padding:5px 8px;border:1px solid var(--color-border);border-radius:7px;background:var(--color-surface-2);font-size:10.5px;color:var(--color-text-muted)">' +
            '<i data-lucide="layout-dashboard" style="width:12px;height:12px;color:var(--color-primary)"></i>' + escapeHtml(dashboardSummary) +
          '</div>' +
          permBadges +
          '</div>';
      });

      html += '</div></div>';
      panel.innerHTML = html;

      var addBtn = document.getElementById('add-user-btn');
      if (addBtn) addBtn.addEventListener('click', showUserModal);

      var addRoleBtn = document.getElementById('add-role-btn');
      if (addRoleBtn) addRoleBtn.addEventListener('click', function(this: any) { showRoleModal(null); });

      document.querySelectorAll('.edit-role-btn').forEach(function(btn: any) {
        btn.addEventListener('click', function(this: any) {
          var roleId = parseInt(this.dataset.roleId, 10);
          var role = null;
          var _editRoles = $rolesList.get() || [];
          for (var ri = 0; ri < _editRoles.length; ri++) {
            if (_editRoles[ri].id === roleId) { role = _editRoles[ri]; break; }
          }
          if (role) showRoleModal(role);
        });
      });

      document.querySelectorAll<HTMLButtonElement>('.accounting-role-btn').forEach(function(btn) {
        btn.addEventListener('click', function(event) {
          event.stopPropagation();
          const role = ($rolesList.get() || []).find(function(item: any) { return String(item.id) === btn.dataset.roleId; });
          if (role) void showRoleAccountingReports(role);
        });
      });

      document.querySelectorAll('.dashboard-role-btn').forEach(function(btn: any) {
        btn.addEventListener('click', function(this: any, e: Event) {
          e.stopPropagation();
          var roleId = parseInt(this.dataset.roleId, 10);
          var role = ($rolesList.get() || []).find(function(item: any) { return item.id === roleId; });
          if (role) showRoleDashboardModal(role);
        });
      });

      document.querySelectorAll('.delete-role-btn').forEach(function(btn: any) {
        btn.addEventListener('click', async function(this: any, e: any) {
          e.stopPropagation();
          var roleId = parseInt(this.dataset.roleId, 10);
          var roleName = this.dataset.roleName || 'tę rolę';
          var ok = await showConfirm(
            'Usuń rolę',
            'Czy na pewno chcesz usunąć rolę „' + roleName + '"?\n\nJeśli rola jest przypisana do użytkowników, zostaniesz spytany czy odpiąć ich automatycznie.',
            { okLabel: 'Usuń', okClass: 'danger' }
          );
          if (!ok) return;
          try {
            await SellBaseAPI.deleteRole(roleId);
            showToast('Rola została usunięta', 'success');
            renderUsersTab({ cicho: true });
          } catch (err: any) {
            // 409 → rola jest przypisana do userów. Pytamy czy force.
            var msg = (err && err.message) || '';
            if (msg.indexOf('przypisana') >= 0 || msg.indexOf('409') >= 0) {
              var force = await showConfirm(
                'Rola w użyciu',
                msg + '\n\nWymusić usunięcie? Użytkownicy zostaną bez roli — będziesz musiał im przypisać nową ręcznie.',
                { okLabel: 'Wymuś usunięcie', okClass: 'danger' }
              );
              if (!force) return;
              try {
                var resp = await SellBaseAPI.deleteRole(roleId, true);
                showToast('Rola usunięta. ' + (resp.users_unassigned || 0) + ' użytkowników bez roli.', 'success');
                renderUsersTab({ cicho: true });
              } catch (err2: any) {
                showToast('Błąd: ' + (err2.message || err2), 'error');
              }
            } else {
              showToast('Błąd: ' + (msg || err), 'error');
            }
          }
        });
      });

      document.querySelectorAll('[data-action="edit-user"]').forEach(function(btn: any) {
        btn.addEventListener('click', function(this: any) {
          var userId = parseInt(this.dataset.id, 10);
          showEditUserModal(userId);
        });
      });

      // 2026-08-25: przełącznik widoku Aktywni | Zarchiwizowani
      document.querySelectorAll('[data-users-view]').forEach(function(btn: any) {
        btn.addEventListener('click', function(this: any) {
          var view = this.dataset.usersView;
          if (view === _usersView) return;
          _usersView = view;
          renderUsersTab({ cicho: true });
        });
      });

      // 2026-08-25: archiwizacja byłych pracowników
      document.querySelectorAll('[data-action="archive-user"]').forEach(function(btn: any) {
        btn.addEventListener('click', function(this: any) {
          archiveUserAction(parseInt(this.dataset.id, 10));
        });
      });
      document.querySelectorAll('[data-action="restore-user"]').forEach(function(btn: any) {
        btn.addEventListener('click', function(this: any) {
          var userId = parseInt(this.dataset.id, 10);
          SellBaseAPI.restoreUser(userId).then(function() {
            showToast('Użytkownik przywrócony do zespołu', 'success');
            renderUsersTab({ cicho: true });
          }).catch(function(err: any) {
            showToast(err.message || 'Nie udało się przywrócić użytkownika', 'error');
          });
        });
      });
      document.querySelectorAll('[data-action="perm-delete-user"]').forEach(function(btn: any) {
        btn.addEventListener('click', function(this: any) {
          permDeleteUserAction(parseInt(this.dataset.id, 10));
        });
      });

      // 2026-07-09: parowanie Telegram — kod jednorazowy + link t.me/<bot>?start=<kod>
      document.querySelectorAll('[data-action="tg-link"]').forEach(function(btn: any) {
        btn.addEventListener('click', async function(this: any) {
          var userId = parseInt(this.dataset.id, 10);
          var userName = this.dataset.name || '';
          try {
            var tok = ((window as any).SellBaseAPI && (window as any).SellBaseAPI.getAuthToken) ? (window as any).SellBaseAPI.getAuthToken() : '';
            var resp = await fetch('/api/telegram/link-code', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', Authorization: 'Bearer ' + tok },
              body: JSON.stringify({ user_id: userId }),
            });
            var data = await resp.json().catch(function() { return {}; });
            if (!resp.ok || !data.ok) {
              showToast('Nie udało się wygenerować kodu: ' + ((data && data.detail) || resp.status), 'error');
              return;
            }
            var linkHtml = data.link
              ? '<a href="' + escapeAttr(data.link) + '" target="_blank" rel="noopener" style="word-break:break-all">' + escapeHtml(data.link) + '</a>'
              : '<span style="color:var(--color-text-muted)">Bot nie odpowiada — sprawdź token w Ustawienia → Produkcja. Kod: <code>' + escapeHtml(data.code) + '</code> (wyślij pracownikowi: /start ' + escapeHtml(data.code) + ')</span>';
            openModal('Połącz Telegram — ' + escapeHtml(userName),
              '<div style="font-size:12.5px;line-height:1.6">' +
                '<p style="margin:0 0 10px">Wyślij pracownikowi ten link — po kliknięciu i naciśnięciu <b>START</b> w Telegramie konto sparuje się automatycznie:</p>' +
                '<div style="padding:10px;border-radius:8px;background:var(--color-bg-secondary,#222);font-size:12px">' + linkHtml + '</div>' +
                '<p style="margin:10px 0 0;color:var(--color-text-muted);font-size:11.5px">Kod jest jednorazowy i ważny 24 h. Od sparowania kliknięcia „✅ Zmontowane" tego pracownika będą podpisane jego kontem SellBase.</p>' +
              '</div>',
              '<button class="btn-secondary" id="tg-link-copy">Kopiuj link</button>' +
              '<button class="btn-primary" id="tg-link-close">Zamknij</button>');
            setTimeout(function() {
              var copyBtn = document.getElementById('tg-link-copy');
              if (copyBtn) copyBtn.addEventListener('click', function() {
                try {
                  navigator.clipboard.writeText(data.link || data.code || '');
                  showToast('Skopiowano', 'success');
                } catch (_eC) { showToast('Nie udało się skopiować', 'error'); }
              });
              // Bez renderUsersTab() — parowanie i tak domyka się dopiero gdy pracownik
              // kliknie START u bota; re-render wyglądał jak refresh strony (UX feedback 2026-07-09)
              var closeBtn = document.getElementById('tg-link-close');
              if (closeBtn) closeBtn.addEventListener('click', function() { closeModal(); });
            }, 60);
          } catch (eL: any) {
            showToast('Błąd: ' + (eL.message || eL), 'error');
          }
        });
      });

      document.querySelectorAll('[data-action="tg-unlink"]').forEach(function(btn: any) {
        btn.addEventListener('click', async function(this: any) {
          var userId = parseInt(this.dataset.id, 10);
          var ok = await showConfirm('Rozłącz Telegram',
            'Odpiąć konto Telegram od tego użytkownika? Jego kliknięcia ✅ przestaną być rozpoznawane.',
            { okLabel: 'Rozłącz', okClass: 'danger' });
          if (!ok) return;
          try {
            var tok2 = ((window as any).SellBaseAPI && (window as any).SellBaseAPI.getAuthToken) ? (window as any).SellBaseAPI.getAuthToken() : '';
            var resp2 = await fetch('/api/telegram/link/' + userId, {
              method: 'DELETE', headers: { Authorization: 'Bearer ' + tok2 },
            });
            if (resp2.ok) { showToast('Rozłączono', 'success'); renderUsersTab({ cicho: true }); }
            else showToast('Błąd rozłączania (' + resp2.status + ')', 'error');
          } catch (eU: any) { showToast('Błąd: ' + (eU.message || eU), 'error'); }
        });
      });

      lucide.createIcons();
      // S-139: po cichym odświeżeniu wróć do scrolla, przy którym user był.
      if (cicho) { panel.scrollTop = zapPanelScroll; window.scrollTo({ top: zapScrollY }); }
    } catch (e: any) {
      panel.innerHTML =
        '<div class="settings-card" style="border-left:3px solid var(--color-error)">' +
          '<div style="padding:var(--space-5)">' +
            '<div style="font-weight:600;color:var(--color-error);margin-bottom:var(--space-2)">Nie udało się pobrać użytkowników</div>' +
            '<div style="font-size:var(--text-sm);color:var(--color-text-muted)">' + escapeHtml(e.message || 'Błąd API') + '</div>' +
          '</div>' +
        '</div>';
    }
}

// ⚠️ Lista MUSI być zsynchronizowana z SELLBASE_MODULES w api_server.py:3230.
// Backend filtruje uprawnienia po tym zbiorze — niepasujący klucz → walidacja
// wyrzuca go i frontend dostaje "brak uprawnień". Aktualizujemy dynamicznie
// przez `/api/modules` przy pierwszym otwarciu modala roli (zob. _ensureModuleDefs).
// 2026-07-16: macierz ról operuje na 7 GRUPACH (nie 15 modułach). Zsynchronizowane
// z SELLBASE_GROUPS w api_server.py; backend GET /api/modules zwraca te same grupy.
var MODULE_DEFS = [
    { key: 'orders',      label: 'Zamówienia i pakowanie',   desc: 'Zamówienia, pakowanie, WzA, klienci' },
    { key: 'support',     label: 'Obsługa klienta',          desc: 'Wiadomości, zwroty, reklamacje — wszystkie kanały' },
    { key: 'invoices',    label: 'Faktury i księgowość',     desc: 'Dokumenty sprzedaży, serie, KSeF, VAT' },
    { key: 'products',    label: 'Produkty i oferty',        desc: 'Katalog, stany, ceny, powiązania ofert' },
    { key: 'marketplace', label: 'Integracje / Marketplace', desc: 'Konta i konfiguracja Allegro, PrestaShop, eBay, Erli, TikTok, InPost' },
    { key: 'accounting_reports', label: 'Księgowość — raporty', desc: 'Wybrane statystyki i pliki PDF, CSV, EPP. Bez edycji danych.' },
    { key: 'analytics',   label: 'Statystyki i pulpit',      desc: 'Dashboard KPI, analityka sprzedaży' },
    { key: 'admin',       label: 'Administracja',            desc: 'Użytkownicy, role, konfiguracja firmy, automatyzacje' },
];

// Pobiera świeżą listę modułów z backendu i nadpisuje MODULE_DEFS gdy dostępna.
// Wywoływane przed renderem modala roli — zapobiega rozjazdom przy zmianach w backend.
var _moduleDefsLoaded = false;
async function _ensureModuleDefs() {
    if (_moduleDefsLoaded) return;
    try {
      var data = await SellBaseAPI.getModules();
      if (Array.isArray(data) && data.length > 0) {
        MODULE_DEFS = data.map(function(m: ModuleDef) {
          return { key: m.key, label: m.label || m.key, desc: m.desc || '' };
        });
        _moduleDefsLoaded = true;
      }
    } catch (e: any) { /* fallback do hardcoded MODULE_DEFS */ }
}

function _buildPermissionsCheckboxes(existingPerms: Record<string, string> | null | undefined) {
    var perms = existingPerms || {};
    var html = '<div style="margin-top:12px">' +
      '<label style="font-weight:600;margin-bottom:8px;display:block">Uprawnienia modułów</label>' +
      '<table class="data-table tbl-karty mod-macierz" style="font-size:12px"><thead><tr>' + // S-160 (MOB-6): moduł jako karta na telefonie
        '<th>Moduł</th><th>Opis</th>' +
        '<th style="text-align:center;width:60px">Brak</th>' +
        '<th style="text-align:center;width:60px">Odczyt</th>' +
        '<th style="text-align:center;width:80px">Odczyt+Zapis</th>' +
      '</tr></thead><tbody>';
    MODULE_DEFS.forEach(function(m: ModuleDef) {
      var val = perms[m.key] || 'none';
      if (m.key === 'accounting_reports' && val === 'write') val = 'read';
      html += '<tr>' +
        '<td style="font-weight:600;white-space:nowrap">' + escapeHtml(m.label) + '</td>' +
        '<td style="color:var(--color-text-muted)">' + escapeHtml(m.desc) + '</td>' +
        '<td style="text-align:center"><input type="radio" name="mod_' + m.key + '" value="none" class="mod-radio" data-module="' + m.key + '"' + (val === 'none' ? ' checked' : '') + '></td>' +
        '<td style="text-align:center"><input type="radio" name="mod_' + m.key + '" value="read" class="mod-radio" data-module="' + m.key + '"' + (val === 'read' ? ' checked' : '') + '></td>' +
        (m.key === 'accounting_reports' ? '<td style="text-align:center" title="Raporty nie zmieniają danych firmy">—</td>' : '<td style="text-align:center"><input type="radio" name="mod_' + m.key + '" value="write" class="mod-radio" data-module="' + m.key + '"' + (val === 'write' ? ' checked' : '') + '></td>') +
      '</tr>';
    });
    html += '</tbody></table></div>';
    return html;
}

function _collectPermissions(form: HTMLElement | null) {
    var perms: Record<string, string> = {};
    MODULE_DEFS.forEach(function(m: ModuleDef) {
      var selected = form!.querySelector('input[name="mod_' + m.key + '"]:checked');
      perms[m.key] = selected ? (selected as HTMLInputElement).value : 'none';
    });
    return perms;
}

// 2026-07-16: sekcja wykluczeń PER OSOBA (nadpisanie roli). Dla każdej z 7 grup select:
// „wg roli" (brak override) / Brak / Odczyt / Zapis. Prefill z user.permissions_override.
// Głównie do „managera minus wybrane grupy", ale działa dla każdej roli.
function _buildUserOverrideSection(user: any) {
    var ovr = (user && user.permissions_override) || {};
    var rows = '';
    MODULE_DEFS.forEach(function(m: ModuleDef) {
      var cur = ovr[m.key]; // undefined = wg roli
      function opt(v: string, lbl: string) {
        var sel = (v === '__role__' ? (cur === undefined || cur === null) : cur === v) ? ' selected' : '';
        return '<option value="' + v + '"' + sel + '>' + lbl + '</option>';
      }
      rows += '<div style="display:flex;align-items:center;justify-content:space-between;gap:10px;padding:6px 0;border-bottom:1px solid var(--color-border)">' +
        '<span style="font-size:12px;font-weight:600">' + escapeHtml(m.label) + '</span>' +
        '<select class="form-select user-ovr-sel" data-group="' + m.key + '" style="max-width:160px;font-size:12px;padding:4px 8px">' +
          opt('__role__', 'wg roli') + opt('none', 'Brak') + opt('read', 'Odczyt') + (m.key === 'accounting_reports' ? '' : opt('write', 'Odczyt+Zapis')) +
        '</select>' +
      '</div>';
    });
    var hasOvr = ovr && Object.keys(ovr).length > 0;
    return '<details class="settings-card" style="margin-top:14px;padding:12px"' + (hasOvr ? ' open' : '') + '>' +
      '<summary style="cursor:pointer;font-weight:600;font-size:13px">Wykluczenia dla tej osoby ' +
        '<span style="font-weight:400;color:var(--color-text-muted);font-size:11px">(nadpisuje rolę — np. „Manager bez Administracji")</span></summary>' +
      '<div style="margin-top:10px">' + rows + '</div>' +
      '<div style="font-size:11px;color:var(--color-text-muted);margin-top:8px">„wg roli" = bez zmian. Ustaw grupę na „Brak" żeby odciąć ją tej osobie mimo uprawnień roli.</div>' +
    '</details>';
}

// ── Settings Drawer (uniwersalny) ──
function openSettingsDrawer(title: any, bodyHtml: any, footerHtml: any) {
    var overlay = document.getElementById('settings-drawer-overlay');
    var drawer = document.getElementById('settings-drawer');
    var titleEl = document.getElementById('settings-drawer-title');
    var bodyEl = document.getElementById('settings-drawer-body');
    var footerEl = document.getElementById('settings-drawer-footer');
    if (!drawer) return;
    if (titleEl) titleEl.textContent = title;
    if (bodyEl) bodyEl.innerHTML = bodyHtml;
    if (footerEl) footerEl.innerHTML = footerHtml;
    if (overlay) overlay.classList.add('active');
    drawer.classList.add('open');
    if (typeof lucide !== 'undefined') lucide.createIcons();
    // Bind close
    var closeBtn = document.getElementById('settings-drawer-close');
    if (closeBtn && !(closeBtn as any)._sdBound) {
      (closeBtn as any)._sdBound = true;
      closeBtn.addEventListener('click', closeSettingsDrawer);
    }
    if (overlay && !(overlay as any)._sdBound) {
      (overlay as any)._sdBound = true;
      overlay.addEventListener('click', closeSettingsDrawer);
    }
}

function closeSettingsDrawer() {
    var overlay = document.getElementById('settings-drawer-overlay');
    var drawer = document.getElementById('settings-drawer');
    if (overlay) overlay.classList.remove('active');
    if (drawer) drawer.classList.remove('open');
}

interface AccountingRoleScope {
    report_ids: string[];
    module_enabled: boolean;
    reports: Array<{ id: string; label: string; formats: string[] }>;
}

async function showRoleAccountingReports(role: any): Promise<void> {
    openSettingsDrawer('Raporty księgowe — ' + roleDisplayName(role.name),
      '<div id="accounting-role-scope"><p role="status">Wczytywanie zakresu raportów…</p></div>',
      '<button class="btn-secondary" onclick="SellBaseApp.closeSettingsDrawer()">Zamknij</button>');
    const root = document.getElementById('accounting-role-scope');
    if (!root) return;
    try {
      const scope: AccountingRoleScope = await (SellBaseAPI as any)._request('GET', '/api/accounting-reports/access/' + encodeURIComponent(role.id));
      if (!root.isConnected) return;
      const selected = new Set(scope.report_ids);
      root.innerHTML = '<p style="font-size:12px;line-height:1.6">Wybierz statystyki oraz raporty dostępne dla tej roli w bieżącej firmie. Brak zaznaczeń oznacza brak dostępu do raportów, także już wygenerowanych. Nowe rodzaje raportów wymagają osobnego przydzielenia.</p>' +
        (!scope.module_enabled ? '<p style="padding:12px;background:rgba(245,158,11,.1);border-radius:8px;font-size:12px">Ta rola ma wyłączony moduł raportów. Po wyborze zakresu włącz „Księgowość — raporty: Odczyt” w uprawnieniach roli.</p>' : '') +
        '<div id="accounting-role-options" style="display:grid;gap:10px;margin:18px 0">' +
          scope.reports.map(item => '<label style="display:flex;gap:10px;align-items:flex-start;padding:12px;border:1px solid var(--color-border);border-radius:8px"><input type="checkbox" value="' + escapeAttr(item.id) + '"' + (selected.has(item.id) ? ' checked' : '') + ' style="margin-top:3px;accent-color:var(--color-primary)"><span><strong style="display:block;font-size:13px">' + escapeHtml(item.label) + '</strong><span style="color:var(--color-text-muted);font-size:11px">' + escapeHtml(item.formats.map(format => format.toUpperCase()).join(', ')) + '</span></span></label>').join('') +
        '</div><p style="font-size:12px;line-height:1.6;color:var(--color-text-muted)">Ten wybór nie nadaje praw do zmiany dokumentów, płatności, kosztów ani ustawień. Pozostałe uprawnienia roli pozostają oddzielne.</p><p id="accounting-role-error" role="alert" style="color:var(--color-error,#ef4444)"></p><button type="button" class="btn-primary" id="accounting-role-save">Zapisz zakres raportów</button>';
      const save = root.querySelector<HTMLButtonElement>('#accounting-role-save')!;
      save.addEventListener('click', async () => {
        const reportIds = Array.from(root.querySelectorAll<HTMLInputElement>('#accounting-role-options input:checked')).map(check => check.value);
        save.disabled = true;
        root.querySelector('#accounting-role-error')!.textContent = '';
        try {
          await (SellBaseAPI as any)._request('PUT', '/api/accounting-reports/access/' + encodeURIComponent(role.id), { report_ids: reportIds });
          if (!root.isConnected) return;
          closeSettingsDrawer();
          showToast('Zapisano zakres raportów księgowych', 'success');
          renderUsersTab({ cicho: true });
        } catch (error) {
          if (root.isConnected) root.querySelector('#accounting-role-error')!.textContent = error instanceof Error ? error.message : 'Nie udało się zapisać zakresu.';
        } finally { save.disabled = false; }
      });
    } catch (error) {
      if (root.isConnected) {
        root.textContent = error instanceof Error ? error.message : 'Nie udało się wczytać zakresu raportów.';
        root.setAttribute('role', 'alert');
      }
    }
}

function showRoleDashboardModal(role: any) {
    var allKeys = allDashboardWidgetKeys();
    var rolePerms = role && role.permissions || {};
    var visible = Array.isArray(role && role.dashboard_visible_widgets)
      ? role.dashboard_visible_widgets.filter(function(key: string) { return allKeys.indexOf(key) !== -1; })
      : ((rolePerms.analytics === 'read' || rolePerms.analytics === 'write') ? allKeys.slice() : []);
    var visibleSet = new Set(visible);
    var groups: Record<string, typeof DASHBOARD_WIDGET_DEFS> = {};
    DASHBOARD_WIDGET_DEFS.forEach(function(widget) {
      if (!groups[widget.group]) groups[widget.group] = [];
      groups[widget.group].push(widget);
    });

    var widgetsHtml = '';
    Object.keys(groups).forEach(function(groupName) {
      widgetsHtml += '<section style="margin-bottom:18px">' +
        '<div style="font-size:11px;font-weight:800;text-transform:uppercase;letter-spacing:.06em;color:var(--color-text-muted);margin:0 0 8px 2px">' + escapeHtml(groupName) + '</div>' +
        '<div style="display:grid;grid-template-columns:repeat(auto-fit,minmax(260px,1fr));gap:8px">';
      groups[groupName].forEach(function(widget) {
        var checked = visibleSet.has(widget.key);
        widgetsHtml += '<label class="dashboard-widget-option" data-widget-key="' + escapeAttr(widget.key) + '" style="display:grid;grid-template-columns:22px 34px minmax(0,1fr);align-items:center;gap:10px;padding:11px;border:1px solid ' + (checked ? 'rgba(79,102,255,.55)' : 'var(--color-border)') + ';border-radius:10px;background:' + (checked ? 'rgba(79,102,255,.08)' : 'var(--color-surface)') + ';cursor:pointer;transition:border-color .15s,background .15s">' +
          '<input type="checkbox" class="dashboard-widget-check" value="' + escapeAttr(widget.key) + '"' + (checked ? ' checked' : '') + ' style="width:17px;height:17px;accent-color:var(--color-primary)">' +
          '<span style="width:34px;height:34px;display:flex;align-items:center;justify-content:center;border-radius:9px;background:var(--color-surface-2);color:var(--color-primary)"><i data-lucide="' + escapeAttr(widget.icon) + '" style="width:17px;height:17px"></i></span>' +
          '<span style="min-width:0"><span style="display:block;font-size:12px;font-weight:700;color:var(--color-text);margin-bottom:2px">' + escapeHtml(widget.label) + '</span>' +
          '<span style="display:block;font-size:10.5px;line-height:1.35;color:var(--color-text-muted)">' + escapeHtml(widget.description) + '</span></span>' +
        '</label>';
      });
      widgetsHtml += '</div></section>';
    });

    var body = '<div style="display:flex;align-items:flex-start;justify-content:space-between;gap:14px;padding:12px 14px;margin-bottom:16px;border:1px solid var(--color-border);border-radius:10px;background:var(--color-surface-2)">' +
        '<div><div style="font-size:13px;font-weight:700;margin-bottom:3px">Widok roli: ' + escapeHtml(roleDisplayName(role && role.name)) + '</div>' +
        '<div style="font-size:11px;color:var(--color-text-muted);line-height:1.45">Zaznaczenie co najmniej jednego elementu włącza zakładkę Dashboard dla tej roli. Odznaczenie wszystkich usuwa zakładkę. Nie nadaje to dostępu do Statystyk ani innych modułów.</div></div>' +
        '<div id="dashboard-widgets-count" style="white-space:nowrap;font-size:11px;font-weight:700;color:var(--color-primary);padding-top:2px"></div>' +
      '</div>' +
      '<div style="display:flex;gap:8px;justify-content:flex-end;margin-bottom:14px">' +
        '<button type="button" class="btn-secondary" id="dashboard-widgets-select-all" style="font-size:11px">Zaznacz wszystkie</button>' +
        '<button type="button" class="btn-secondary" id="dashboard-widgets-clear-all" style="font-size:11px">Odznacz wszystkie</button>' +
      '</div>' +
      '<div id="dashboard-widgets-form">' + widgetsHtml + '</div>' +
      '<div style="display:flex;align-items:center;gap:7px;padding:10px 12px;border-radius:9px;background:rgba(59,130,246,.08);color:var(--color-text-muted);font-size:10.5px;line-height:1.4">' +
        '<i data-lucide="info" style="width:15px;height:15px;flex:0 0 auto;color:var(--color-info,#3b82f6)"></i>' +
        'Zmiana dotyczy tej roli tylko w bieżącej firmie. Nie zmienia widoku tej samej roli w innych firmach.' +
      '</div>';

    var footer = '<button class="btn-secondary" onclick="SellBaseApp.closeSettingsDrawer()">Anuluj</button>' +
      '<button class="btn-primary" id="save-role-dashboard-btn"><i data-lucide="check" style="width:15px;height:15px"></i> Zapisz widok</button>';

    openSettingsDrawer('Elementy Dashboardu', body, footer);

    setTimeout(function() {
      var form = document.getElementById('dashboard-widgets-form');
      var countEl = document.getElementById('dashboard-widgets-count');
      var saveBtn = document.getElementById('save-role-dashboard-btn') as HTMLButtonElement | null;
      if (!form || !saveBtn) return;
      var formEl = form as HTMLElement;

      var updateState = function() {
        var checks = Array.from(formEl.querySelectorAll<HTMLInputElement>('.dashboard-widget-check'));
        var selected = checks.filter(function(check) { return check.checked; }).length;
        if (countEl) countEl.textContent = selected
          ? selected + ' z ' + checks.length + ' — Dashboard włączony'
          : '0 z ' + checks.length + ' — Dashboard wyłączony';
        checks.forEach(function(check) {
          var card = check.closest('.dashboard-widget-option') as HTMLElement | null;
          if (!card) return;
          card.style.borderColor = check.checked ? 'rgba(79,102,255,.55)' : 'var(--color-border)';
          card.style.background = check.checked ? 'rgba(79,102,255,.08)' : 'var(--color-surface)';
        });
      };
      formEl.querySelectorAll<HTMLInputElement>('.dashboard-widget-check').forEach(function(check) {
        check.addEventListener('change', updateState);
      });
      document.getElementById('dashboard-widgets-select-all')?.addEventListener('click', function() {
        formEl.querySelectorAll<HTMLInputElement>('.dashboard-widget-check').forEach(function(check) { check.checked = true; });
        updateState();
      });
      document.getElementById('dashboard-widgets-clear-all')?.addEventListener('click', function() {
        formEl.querySelectorAll<HTMLInputElement>('.dashboard-widget-check').forEach(function(check) { check.checked = false; });
        updateState();
      });
      saveBtn.addEventListener('click', function() {
        var selected = Array.from(formEl.querySelectorAll<HTMLInputElement>('.dashboard-widget-check:checked')).map(function(check) { return check.value; });
        saveBtn!.disabled = true;
        saveBtn!.innerHTML = '<i data-lucide="loader-2" class="spin" style="width:15px;height:15px"></i> Zapisywanie…';
        if (typeof lucide !== 'undefined') lucide.createIcons();
        SellBaseAPI.updateRoleDashboardWidgets(role.id, selected).then(function() {
          // P8: zapomnij zapamiętany (30 s) zestaw widgetów — powrót na Pulpit pokaże nowy widok roli.
          try { const _rs = (window as any).resetDashboardWidgetVisibilityCache; if (typeof _rs === 'function') _rs(); } catch (_e) { /* noop */ }
          closeSettingsDrawer();
          showToast(selected.length
            ? 'Dashboard dla roli został włączony'
            : 'Dashboard dla roli został wyłączony', 'success');
          renderUsersTab({ cicho: true });
        }).catch(function(err: any) {
          saveBtn!.disabled = false;
          saveBtn!.innerHTML = '<i data-lucide="check" style="width:15px;height:15px"></i> Zapisz widok';
          if (typeof lucide !== 'undefined') lucide.createIcons();
          showToast(err.message || 'Nie udało się zapisać widoku Dashboardu', 'error');
        });
      });
      updateState();
      if (typeof lucide !== 'undefined') lucide.createIcons();
    }, 50);
}

async function showRoleModal(editRole: any) {
    // Najpierw zsynchronizuj listę modułów z backendem (jednorazowo na sesję)
    await _ensureModuleDefs();
    var isEdit = !!editRole;
    var existingPerms = (editRole && editRole.permissions) || {};
    var body =
      '<form class="settings-form" id="role-modal-form">' +
        '<div class="form-grid">' +
          '<div class="form-group full-width"><label>Nazwa roli</label><input type="text" class="form-input" name="name" placeholder="np. księgowość" value="' + escapeAttr((editRole && editRole.name) || '') + '"' + (isEdit ? ' readonly style="opacity:0.6"' : '') + '></div>' +
          '<div class="form-group full-width"><label>Opis</label><input type="text" class="form-input" name="description" placeholder="Opis roli" value="' + escapeAttr((editRole && editRole.description) || '') + '"></div>' +
        '</div>' +
        _buildPermissionsCheckboxes(existingPerms) +
      '</form>';

    var footer =
      '<button class="btn-secondary" onclick="SellBaseApp.closeSettingsDrawer()">Anuluj</button>' +
      '<button class="btn-primary" id="save-role-btn">' + (isEdit ? 'Zapisz zmiany' : 'Dodaj rolę') + '</button>';

    openSettingsDrawer(isEdit ? 'Edytuj rolę' : 'Dodaj rolę', body, footer);

    setTimeout(function() {
      var saveBtn = document.getElementById('save-role-btn');
      if (!saveBtn) return;
      saveBtn.addEventListener('click', function(this: any) {
        var form = document.getElementById('role-modal-form');
        var name = (form?.querySelector('[name="name"]') as any)?.value.trim();
        var description = (form?.querySelector('[name="description"]') as any)?.value.trim();
        var permissions = _collectPermissions(form);

        if (!name) {
          showToast('Podaj nazwę roli', 'error');
          return;
        }

        var apiCall;
        if (isEdit && editRole.is_system) {
          apiCall = SellBaseAPI.updateRolePermissions(editRole.id, permissions);
        } else if (isEdit) {
          apiCall = SellBaseAPI.updateRole(editRole.id, { description: description, permissions: permissions });
        } else {
          apiCall = SellBaseAPI.createRole({ name: name, description: description, permissions: permissions });
        }

        apiCall.then(function() {
          closeSettingsDrawer();
          showToast(isEdit ? 'Rola zaktualizowana' : 'Rola została dodana', 'success');
          renderUsersTab({ cicho: true });
        }).catch(function(err: any) {
          showToast(err.message || 'Nie udało się zapisać roli', 'error');
        });
      });
    }, 50);
}

function showUserModal() {
    // 2026-07-16: bezpieczny default — pusta opcja wymusza świadomy wybór roli
    // (był preselekt „Admin" = nieuwaga tworzyła pełnego admina firmy).
    var roleOptions = '<option value="" selected disabled>— wybierz rolę —</option>';
    ($rolesList.get() || []).forEach(function(r: any) {
      if (!canAssignRole(r)) return;
      roleOptions += '<option value="' + r.id + '">' + escapeHtml(roleDisplayName(r.name)) + '</option>';
    });

    var body =
      '<form class="settings-form" id="user-modal-form">' +
        '<div class="form-grid">' +
          '<div class="form-group"><label>Imię</label><input type="text" class="form-input" name="first_name" placeholder="Jan"></div>' +
          '<div class="form-group"><label>Nazwisko</label><input type="text" class="form-input" name="last_name" placeholder="Kowalski"></div>' +
          '<div class="form-group full-width"><label>Email</label><input type="email" class="form-input" name="email" placeholder="jan@firma.pl"></div>' +
          '<div class="form-group"><label>Rola</label><select class="form-select" name="role_id">' + roleOptions + '</select></div>' +
          '<div class="form-group full-width"><label>Hasło</label><input type="password" class="form-input" name="password" placeholder="Minimum 8 znaków"></div>' +
        '</div>' +
      '</form>';

    var footer =
      '<button class="btn-secondary" onclick="SellBaseApp.closeSettingsDrawer()">Anuluj</button>' +
      '<button class="btn-primary" id="save-user-btn">Dodaj użytkownika</button>';

    openSettingsDrawer('Dodaj użytkownika', body, footer);

    setTimeout(function() {
      var saveBtn = document.getElementById('save-user-btn');
      if (!saveBtn) return;
      saveBtn.addEventListener('click', function(this: any) {
        var form = document.getElementById('user-modal-form');
        var payload = {
          first_name: (form?.querySelector('[name="first_name"]') as any)?.value.trim(),
          last_name: (form?.querySelector('[name="last_name"]') as any)?.value.trim(),
          email: (form?.querySelector('[name="email"]') as any)?.value.trim(),
          role_id: parseInt((form?.querySelector('[name="role_id"]') as any)?.value, 10),
          password: (form?.querySelector('[name="password"]') as any)?.value
        } as any;

        if (!payload.first_name || !payload.last_name || !payload.email || !payload.password) {
          showToast('Wypełnij wszystkie wymagane pola', 'error');
          return;
        }
        if (!payload.role_id || isNaN(payload.role_id)) {
          showToast('Wybierz rolę użytkownika', 'error');
          return;
        }

        SellBaseAPI.createUser(payload).then(function() {
          closeSettingsDrawer();
          showToast('Użytkownik został dodany', 'success');
          renderUsersTab({ cicho: true });
        }).catch(function(err: any) {
          showToast(err.message || 'Nie udało się dodać użytkownika', 'error');
        });
      });
    }, 50);
}

function showEditUserModal(userId: any) {
    var user: any = null;
    var _editUsers = $usersList.get() || [];
    for (var i = 0; i < _editUsers.length; i++) {
      if (_editUsers[i].id === userId) {
        user = _editUsers[i];
        break;
      }
    }
    if (!user) return;
    if (!canMutateUser(user)) {
      showToast('Konto właściciela jest chronione przed administratorami', 'error');
      return;
    }

    var roleOptions = '';
    ($rolesList.get() || []).forEach(function(r: any) {
      if (!canAssignRole(r) && !(user.role && user.role.id === r.id)) return;
      var selected = (user.role && user.role.id === r.id) ? ' selected' : '';
      roleOptions += '<option value="' + r.id + '"' + selected + '>' + escapeHtml(roleDisplayName(r.name)) + '</option>';
    });

    var body =
      '<form class="settings-form" id="edit-user-form">' +
        '<div class="form-grid">' +
          '<div class="form-group"><label>Imię</label><input type="text" class="form-input" name="first_name" value="' + escapeAttr(user.first_name || '') + '"></div>' +
          '<div class="form-group"><label>Nazwisko</label><input type="text" class="form-input" name="last_name" value="' + escapeAttr(user.last_name || '') + '"></div>' +
          '<div class="form-group full-width"><label>Email</label><input type="email" class="form-input" name="email" value="' + escapeAttr(user.email || '') + '"></div>' +
          '<div class="form-group"><label>Rola</label><select class="form-select" name="role_id">' + roleOptions + '</select></div>' +
          '<div class="form-group full-width"><label>Nowe hasło (opcjonalnie)</label><input type="password" class="form-input" name="password" placeholder="Zostaw puste, aby nie zmieniać"></div>' +
        '</div>' +
        (isOwnerUser(user) ? '' : _buildUserOverrideSection(user)) +
      '</form>';

    var footer =
      '<button class="btn-secondary" onclick="SellBaseApp.closeSettingsDrawer()">Anuluj</button>' +
      '<button class="btn-primary" id="update-user-btn">Zapisz zmiany</button>';

    openSettingsDrawer('Edytuj użytkownika', body, footer);

    setTimeout(function() {
      var updateBtn = document.getElementById('update-user-btn');
      if (!updateBtn) return;
      updateBtn.addEventListener('click', function(this: any) {
        var form = document.getElementById('edit-user-form');
        var payload = {
          first_name: (form?.querySelector('[name="first_name"]') as any)?.value.trim(),
          last_name: (form?.querySelector('[name="last_name"]') as any)?.value.trim(),
          email: (form?.querySelector('[name="email"]') as any)?.value.trim(),
          role_id: parseInt((form?.querySelector('[name="role_id"]') as any)?.value, 10)
        } as any;

        var password = (form?.querySelector('[name="password"]') as any)?.value;
        if (password) payload.password = password;

        // 2026-07-16: per-user override (wykluczenia). Zbierz grupy z override != „wg roli".
        if (!isOwnerUser(user)) {
          var ovr: Record<string, string> = {};
          (form ? form.querySelectorAll('.user-ovr-sel') : []).forEach(function(sel: any) {
            var g = sel.dataset.group; var v = sel.value;
            if (g && v && v !== '__role__') ovr[g] = v;
          });
          payload.permissions_json = ovr; // {} = brak override (czyści)
        }

        SellBaseAPI.updateUser(userId, payload).then(function() {
          closeSettingsDrawer();
          showToast('Dane użytkownika zaktualizowane', 'success');
          renderUsersTab({ cicho: true });
        }).catch(function(err: any) {
          showToast(err.message || 'Nie udało się zaktualizować użytkownika', 'error');
        });
      });
    }, 50);
}

// 2026-08-25: blokowanie userów wycofane (funkcja deleteUser usunięta) —
// jedyna zmiana stanu konta to archiwizacja.

function _findUserById(userId: any) {
    var list = $usersList.get() || [];
    for (var i = 0; i < list.length; i++) {
      if (list[i].id === userId) return list[i];
    }
    return null;
}

function archiveUserAction(userId: any) {
    var user = _findUserById(userId);
    if (!user || !canMutateUser(user)) return;
    var name = escapeHtml(((user.first_name || '') + ' ' + (user.last_name || '')).trim() || user.email || '');

    var body = '<p style="font-size:var(--text-sm);color:var(--color-text)">Zarchiwizować użytkownika <strong>' + name + '</strong> (' + escapeHtml(user.email || '') + ')?</p>' +
      '<p style="font-size:var(--text-xs);color:var(--color-text-muted);margin-top:8px">Straci dostęp do SellBase, zniknie z widoków zespołu i list wyboru, a jego parowanie Telegram zostanie rozłączone. Historia pracy (statystyki, pakowanie) zostaje. Możesz go w każdej chwili przywrócić z sekcji „Zarchiwizowani".</p>';
    var footer =
      '<button class="btn-secondary" onclick="SellBaseApp.closeModal()">Anuluj</button>' +
      '<button class="btn-primary" id="confirm-archive-user" style="height:36px;padding:var(--space-2) var(--space-4);">Archiwizuj</button>';
    openModal('Archiwizuj użytkownika', body, footer);

    setTimeout(function() {
      var confirmBtn = document.getElementById('confirm-archive-user');
      if (!confirmBtn) return;
      confirmBtn.addEventListener('click', function() {
        SellBaseAPI.archiveUser(userId).then(function() {
          closeModal();
          showToast('Użytkownik został zarchiwizowany', 'success');
          renderUsersTab({ cicho: true });
        }).catch(function(err: any) {
          showToast(err.message || 'Nie udało się zarchiwizować użytkownika', 'error');
        });
      });
    }, 50);
}

function permDeleteUserAction(userId: any) {
    var user = _findUserById(userId);
    if (!user || !canManageOwnerAccounts()) return;
    var name = escapeHtml(((user.first_name || '') + ' ' + (user.last_name || '')).trim() || user.email || '');

    var body = '<p style="font-size:var(--text-sm);color:var(--color-text)">Definitywnie usunąć użytkownika <strong>' + name + '</strong> (' + escapeHtml(user.email || '') + ')?</p>' +
      '<p style="font-size:var(--text-xs);color:var(--color-error,#ef4444);margin-top:8px"><strong>Tej operacji nie da się cofnąć.</strong> Dane osobowe i dostępowe zostaną trwale wyczyszczone. W historycznych statystykach pozostanie anonimowy wpis „Usunięty pracownik".</p>';
    var footer =
      '<button class="btn-secondary" onclick="SellBaseApp.closeModal()">Anuluj</button>' +
      '<button class="btn-sm danger" id="confirm-perm-delete-user" style="height:36px;padding:var(--space-2) var(--space-4);">Usuń definitywnie</button>';
    openModal('Usuń definitywnie', body, footer);

    setTimeout(function() {
      var confirmBtn = document.getElementById('confirm-perm-delete-user');
      if (!confirmBtn) return;
      confirmBtn.addEventListener('click', function() {
        SellBaseAPI.deleteUserPermanently(userId).then(function() {
          closeModal();
          showToast('Użytkownik został definitywnie usunięty', 'success');
          renderUsersTab({ cicho: true });
        }).catch(function(err: any) {
          showToast(err.message || 'Nie udało się usunąć użytkownika', 'error');
        });
      });
    }, 50);
}

/* -----------------------------------------------
     Settings — Order Statuses Tab
     ----------------------------------------------- */
var _activeStatusCategory = 'order';
var _stDragged: any = null; // globalny stan drag & drop dla drzewka statusów
// Faza C.3 — mirror dla status-tree module (closure-bound mutable vars)
(window as any).__sbStateExt = (window as any).__sbStateExt || {};
Object.defineProperty((window as any).__sbStateExt, '_stDragged', { get: function() { return _stDragged; }, set: function(v) { _stDragged = v; }, configurable: true });
Object.defineProperty((window as any).__sbStateExt, '_activeStatusCategory', { get: function() { return _activeStatusCategory; }, set: function(v) { _activeStatusCategory = v; }, configurable: true });

// Scope'y Erli obsługiwane per kategoria SellBase — wystaw na window żeby status-tree.js IIFE też miał dostęp
var ERLI_CATEGORY_SCOPES = {
    order: ['seller_status', 'status'],
    payment: ['payment_status'],
    shipment: ['tracking_status']
};
window.ERLI_CATEGORY_SCOPES = ERLI_CATEGORY_SCOPES;
var ERLI_SCOPE_LABELS: Record<string, string> = {seller_status: 'sellerStatus',
    status: 'status',
    payment_status: 'payment.status',
    tracking_status: 'tracking.status'
};
window.ERLI_SCOPE_LABELS = ERLI_SCOPE_LABELS;
var ERLI_SCOPE_SECTION_TITLE: Record<string, string> = {seller_status: 'Seller Status (workflow realizacji)',
    status: 'Base Status (pomocniczy)',
    payment_status: 'Payment Status (status p\u0142atno\u015bci)',
    tracking_status: 'Tracking Status (status dostawy)'
};
window.ERLI_SCOPE_SECTION_TITLE = ERLI_SCOPE_SECTION_TITLE;

// eBay scope mapping (3 kategorie SellBase \u2194 4 scope'y eBay) \u2014 wystaw na window
var EBAY_CATEGORY_SCOPES = {
    order: ['fulfillment_status', 'order_payment_status'],
    payment: ['payment_status'],
    shipment: ['shipment_status']
};
window.EBAY_CATEGORY_SCOPES = EBAY_CATEGORY_SCOPES;
var EBAY_SCOPE_LABELS: Record<string, string> = {fulfillment_status:   'orderFulfillmentStatus',
    order_payment_status: 'orderPaymentStatus',
    payment_status:       'payments[].paymentStatus',
    shipment_status:      'shippingFulfillments[].shipmentStatus'
};
window.EBAY_SCOPE_LABELS = EBAY_SCOPE_LABELS;
var EBAY_SCOPE_SECTION_TITLE: Record<string, string> = {fulfillment_status:   'Fulfillment Status (status realizacji)',
    order_payment_status: 'Order Payment Status (status p\u0142atno\u015bci zam\u00f3wienia)',
    payment_status:       'Payment Status (status p\u0142atno\u015bci)',
    shipment_status:      'Shipment Status (status wysy\u0142ki)'
};
window.EBAY_SCOPE_SECTION_TITLE = EBAY_SCOPE_SECTION_TITLE;


// ── EXPOSE: extracted functions ──
(window as any).SellBaseApp = (window as any).SellBaseApp || {};
(window as any)._buildPermissionsCheckboxes = _buildPermissionsCheckboxes; (window as any).SellBaseApp._buildPermissionsCheckboxes = _buildPermissionsCheckboxes;
(window as any)._collectPermissions = _collectPermissions; (window as any).SellBaseApp._collectPermissions = _collectPermissions;
(window as any)._ensureModuleDefs = _ensureModuleDefs; (window as any).SellBaseApp._ensureModuleDefs = _ensureModuleDefs;
window.activateSettingsTab = activateSettingsTab; (window as any).SellBaseApp.activateSettingsTab = activateSettingsTab;
window.bindEmailTabActions = bindEmailTabActions; (window as any).SellBaseApp.bindEmailTabActions = bindEmailTabActions;
window.canManageUpdates = canManageUpdates; (window as any).SellBaseApp.canManageUpdates = canManageUpdates;
window.canManageUsers = canManageUsers; (window as any).SellBaseApp.canManageUsers = canManageUsers;
window.closeSettingsDrawer = closeSettingsDrawer; (window as any).SellBaseApp.closeSettingsDrawer = closeSettingsDrawer;
window.findAllegroAccountById = findAllegroAccountById; (window as any).SellBaseApp.findAllegroAccountById = findAllegroAccountById;
window.getAccountDisplayName = getAccountDisplayName; (window as any).SellBaseApp.getAccountDisplayName = getAccountDisplayName;
window.getInPostStatusSummary = getInPostStatusSummary; (window as any).SellBaseApp.getInPostStatusSummary = getInPostStatusSummary;
window.openEmailTemplateModal = openEmailTemplateModal; (window as any).SellBaseApp.openEmailTemplateModal = openEmailTemplateModal;
window.openSettingsDrawer = openSettingsDrawer; (window as any).SellBaseApp.openSettingsDrawer = openSettingsDrawer;
window.openUpdateModal = openUpdateModal; (window as any).SellBaseApp.openUpdateModal = openUpdateModal;
window.renderCompanyTab = renderCompanyTab; (window as any).SellBaseApp.renderCompanyTab = renderCompanyTab;
window.renderP4uTab = renderP4uTab; (window as any).SellBaseApp.renderP4uTab = renderP4uTab;
window.renderEmailTab = renderEmailTab; (window as any).SellBaseApp.renderEmailTab = renderEmailTab;
window.renderSettings = renderSettings; (window as any).SellBaseApp.renderSettings = renderSettings;
window.renderUpdateTypeLabel = renderUpdateTypeLabel; (window as any).SellBaseApp.renderUpdateTypeLabel = renderUpdateTypeLabel;
window.renderUpdatesTab = renderUpdatesTab; (window as any).SellBaseApp.renderUpdatesTab = renderUpdatesTab;
window.renderUsersTab = renderUsersTab; (window as any).SellBaseApp.renderUsersTab = renderUsersTab;
window.roleDisplayName = roleDisplayName; (window as any).SellBaseApp.roleDisplayName = roleDisplayName;
window.showEditUserModal = showEditUserModal; (window as any).SellBaseApp.showEditUserModal = showEditUserModal;
window.showRoleModal = showRoleModal; (window as any).SellBaseApp.showRoleModal = showRoleModal;
window.showUserModal = showUserModal; (window as any).SellBaseApp.showUserModal = showUserModal;

// ── ES Module exports ──
export {
  _buildPermissionsCheckboxes,
  _collectPermissions,
  _ensureModuleDefs,
  activateSettingsTab,
  bindEmailTabActions,
  canManageUpdates,
  canManageUsers,
  closeSettingsDrawer,
  findAllegroAccountById,
  getAccountDisplayName,
  getInPostStatusSummary,
  openEmailTemplateModal,
  openSettingsDrawer,
  openUpdateModal,
  renderCompanyTab,
  renderP4uTab,
  renderEmailTab,
  renderSettings,
  renderUpdateTypeLabel,
  renderUpdatesTab,
  renderUsersTab,
  roleDisplayName,
  showEditUserModal,
  showRoleModal,
  showUserModal,
};
